import React, { useState, useEffect, CSSProperties, useRef, forwardRef, useImperativeHandle } from 'react';
import { BrowserRouter as Router, Link, Route, Routes, useParams } from "react-router-dom";
import 'react-awesome-slider/dist/styles.css';
import HashLoader from "react-spinners/ClipLoader";
import Carousel from "nuka-carousel";
import {Helmet} from "react-helmet";
//import { Helmet, HelmetProvider } from "react-helmet-async";

import {isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet} from 'react-device-detect';

import {PullToRefresh, PullDownContent, ReleaseContent, RefreshContent} from "react-js-pull-to-refresh";

import usePostMilestones from '../hooks/usePostMilestones';

// 1. Import the functions
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock';
//import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks, BodyScrollOptions } from 'body-scroll-lock-upgrade';

// Assuming logo.png is in the same folder as JS file
// import playIcon from '../assets/icon/play.png';
// import pauseIcon from '../assets/icon/pause.png';
// import playIconNew from '../assets/icon/ic_vedio_play_x.png';
// import logo from '../assets/img/logo-1.png';
// import KUDO_URL from '../assets/icon/kudos_gray.png';
import KUDO_LINE_URL from '../assets/icon/Kudo/kudos_line.png';
import KUDO_FILL_URL from '../assets/icon/Kudo/kudos_line.png';
import SAY_URL from '../assets/icon/Message/say_line.png';
import SPREAD_URL from '../assets/icon/Spread/spread_line.png';
import MILES_URL from '../assets/icon/ic_travelbuddy_new_x.png';
import cobaltLevelIcon from '../assets/icon/Explurger Level/Cobalt Level/cobalt.imageset/cobalt@2x.png';
import silverLevelIcon from '../assets/icon/Explurger Level/Silver Level/silver.imageset/silver@2x.png';
import goldLevelIcon from '../assets/icon/Explurger Level/Gold Level/gold.imageset/gold@2x.png';
import spectraLevelIcon from '../assets/icon/Explurger Level/Spectra/platinum.imageset/platinum@2x.png';
import primeLevelIcon from '../assets/icon/Explurger Level/Prime/prime.imageset/prime@3x.png';

import save_to_collection from '../assets/icon/save_to_collection.png';
import eyeFillIcon1x from '../assets/icon/eye_fill@1x.png';
//import crossIcon3x from '../assets/icon/icone-x-bleue.png';

import business_badge from '../assets/cdn_img/business_badge@2x.png';
import verified_icon from '../assets/cdn_img/verified-icon.png';

import splashScreen from '../assets/img/sonu-sood.jpeg';

import * as constants from '../constants';

import videojs from 'video.js';
// import VideoJSExplr from './VideoJSExplr';
import CropImage from './CropImage';
import CropImagePlacePhoto from './CropImagePlacePhoto';
import CropProfileImage from './CropProfileImage';
//import CommonComponent from './CommonComponent';
import { CommonScrollUtils } from "./CommonScrollUtils";

import useWindowDimensions from '../hooks/useWindowDimensions';
import ReactHtmlParser from 'react-html-parser';
import {localStorageTTL, getLocalStorage, setLocalStorage} from '../hooks/localStorageWithTTL';
import {util_isObjectEmpty, util_isObjectNotEmpty, util_getPostDataFetchKey, parseTextSinglePass} from '../hooks/util';
import {openAppOrStore} from '../hooks/openAppOrStore';

import {safeParsePreviewMetadata, safeDecode} from '../hooks/util_json';

//import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';

import moment from"moment";

// Post_Type  Spread_Type	Post Name        Post_ID
//     0	      0	        Explurged In      44824 / 44827- with media
//     1	      0	        Pictures/Videos   44117/44115
//     2	      0	        Travelling to     
//     3	      0	        Will go to        44110
//     4	      0	        along with        44121/44122
//     5	      0	        Says              44120/44105/44119
//     6	      0	        journey so far    44097/44096/44094/44092/44091
//     7	      0	        Profile Picture   44103
//     8	      0	        Cover Picture     44104
//     9	      0	        Link Preview      44126/44127/44125

// 44210 spreded

// Nigam Kr - 22a9a9b6e3ea868aa64b3e539d4f440e
// Beauty - k76he9z4sjas58qq3c5l3jqgmpw1653371096324

export const ViewPost = (props) => {
//export default function ViewPost(props) {
    //const pullToRefreshtriggerHeight = "100";
    //const { id } = useParams();
    const [postData, setPostData] = useState([]);
    const [postCreatorInfo, setPostCreatorInfo] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [isHovering, setIsHovering] = useState(false);
    const {width, height} = useWindowDimensions();

    const [metaTagData, setMetaTagData] = useState({});

    const {attr_id, sendDataToParent, dontDismissModelHide, resfreshAllowed} = props; 

    //const [userId, setUserId] = useState(null);
    const hasRun = useRef(false);

    const maxBoxWidth1024 = 1024;
    const maxBoxWidth768 = 768;
    const maxBoxWidth = 425;
    const maxBoxWidth426 = 426;
    const maxBoxPadding = 4;
    const maxBoxPaddingWidthFull = 3;
    const maxBoxPaddingHeightFull = 0;

    const postCountMaxModelSet = 10; // 300/3
    const postCountMaxModelTimes = 3;
    const [fullProfileInAppModalClose, setFullProfileInAppModalClose] = useState(0); 
    var previousP = -1; 

    const postCountMaxModel = 10;
    const timeoutBottomModel = 60 * 1000; // in milliseconds (60 Seconds)
    const postSlideMaxModel = 3;
    const timeoutDontDismissModel = 30 * 1000; // in milliseconds (30 Seconds)

    const bottomModelHide = useRef(true);
    //const dontDismissModelHide = useRef(true);
    const wScrollYPosition = useRef(0);
    const wScrollYPositionEnd = useRef(0);
    const initialized = useRef(false);
    const [modalBox, setModalBox] = React.useState({
        showModal:false,
        slideIndex:-1,
        modalPost:null
    });
    const [modalBox2, setModalBox2] = React.useState({
        showModal:false,
        slideIndex:-1,
        modalPost:null
    });
    
    //const BottomModalOpen = CommonComponent.BottomModalOpen;
    //const clickCenterModalOpen = CommonComponent.clickCenterModalOpen;

    let scrollPosition = 0;

    const optionsBodyScrollOptions = {
        reserveScrollBarGap: true,
    };

    const lockScroll = (targetElement) => {
        // console.log('ViewPost-lockScroll:targetElement:',targetElement);
        // console.log('ViewPost-lockScroll:isIOS:',isIOS);
        scrollPosition = window.scrollY;
        if (targetElement) {
            if( ! isIOS){
                document.body.style.overflow = 'hidden';
                document.documentElement.style.overflow = "hidden";
            }            
            disableBodyScroll(targetElement, optionsBodyScrollOptions);
        }
        setLocalStorage('model_popup_scrollPosition', scrollPosition, 15 * 60);
        //console.log('ViewPost-lockScroll:scrollPosition:',scrollPosition);
    };
    
    const unlockScroll = (targetElement) => {
        // console.log('ViewPost-unlockScroll:targetElement:',targetElement);
        // console.log('ViewPost-unlockScroll:isIOS:',isIOS);
        if (targetElement) {
            if( ! isIOS){
                document.body.style.overflow = 'unset';
                document.documentElement.style.overflow = "scroll";
            }
            enableBodyScroll(targetElement);
        }
        var _scrollPosition = getLocalStorage('model_popup_scrollPosition');
        scrollPosition = _scrollPosition;
        //console.log('ViewPost-unlockScroll:_scrollPosition:',_scrollPosition);
        // if(isIOS)
        //     window.scrollTo(0, _scrollPosition);
    };
    
    /************************************** Start Fix iOS Popup scroll in iphone */

    // const handleChildClick_lockScrollNew = () => {
    //     console.log("ViewPost-handleChildClick_lockScrollNew ");
    //     lockScrollNew();
    // };

    // const handleChildClick_unlockScrollNew = () => {
    //     console.log("ViewPost-handleChildClick_unlockScrollNew ");
    //     unlockScrollNew();
    // };

    // const handleChildClick_preventTouchScroll = () => {
    //     console.log("ViewPost-handleChildClick_preventTouchScroll ");
    //     preventTouchScroll();
    // };

    // const handleChildClick_enableTouchBlock = () => {
    //     console.log("ViewPost-handleChildClick_enableTouchBlock ");
    //     enableTouchBlock();
    // };

    // const handleChildClick_disableTouchBlock = () => {
    //     console.log("ViewPost-handleChildClick_disableTouchBlock ");
    //     disableTouchBlock();
    // };

    // let scrollYiOS = 0;

    const lockScrollNew = () => {
        //console.log("ViewPost-lockScrollNew ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     // document.body.style.overflow = "hidden";
        //     // document.body.style.position = "fixed";
        //     // document.body.style.width = "100%";

        //     scrollYiOS = window.scrollY; // save current scroll
        //     document.body.style.position = "fixed";
        //     document.body.style.top = `-${scrollYiOS}px`;
        //     document.body.style.left = "0";
        //     document.body.style.right = "0";
        //     document.body.style.width = "100%";              
        // }
        CommonScrollUtils.lockScroll();
    };

    const unlockScrollNew = () => {
        //console.log("ViewPost-unlockScrollNew ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     // document.body.style.overflow = "";
        //     // document.body.style.position = "";
        //     // document.body.style.width = "";

        //     document.body.style.position = "";
        //     document.body.style.top = "";
        //     document.body.style.left = "";
        //     document.body.style.right = "";
        //     document.body.style.width = "";
        //     window.scrollTo(0, scrollYiOS); // restore scroll             
        // }
        CommonScrollUtils.unlockScroll();
    };  
    
    const preventTouchScroll = (e) => {
        //console.log("ViewPost-preventTouchScroll ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     e.preventDefault();
        // }
        CommonScrollUtils.preventTouchScroll(e);
    };

    const enableTouchBlock = () => {
        //console.log("ViewPost-enableTouchBlock ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     document.body.addEventListener("touchmove", preventTouchScroll, { passive: false });
        // }
        CommonScrollUtils.enableTouchBlock();
    };

    const disableTouchBlock = () => {
        //console.log("ViewPost-disableTouchBlock ");
        // if(constants.IOS_ON_OFF_TOUCH_MOVE==1 && isIOS)
        // {
        //     document.body.removeEventListener("touchmove", preventTouchScroll);
        // }
        CommonScrollUtils.disableTouchBlock();
    };    

    /************************************** End Fix iOS Popup scroll in iphone */

    // useEffect(() => {
    //     //console.log('Component did mount');
    
    //     // Perform any setup or side-effects

    //     return () => {
    //         //console.log('Component will unmount');
    //         // Perform cleanup here (e.g., removing event listeners)

    //         // 5. Useful if we have called disableBodyScroll for multiple target elements,
    //         // and we just want a kill-switch to undo all that.
    //         // OR useful for if the `hideTargetElement()` function got circumvented eg. visitor
    //         // clicks a link which takes him/her to a different page within the app.
    //         clearAllBodyScrollLocks();

    //     };
    // }, []); // Empty array ensures this effect runs only on mount/unmount    


    function shuffleArray(array) {
        for (var i = array.length - 1; i > 0; i--) { 
       
            // Generate random number 
            var j = Math.floor(Math.random() * (i + 1));
                       
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }
           
        return array;
    }
    

    function handleDataToParent(data) {

        setPostCreatorInfo(data);
        sendDataToParent(data);
    }

    // function handleDataToParentDontDismissModelHide(data) {
    //     sendDataToParentDontDismissModelHide(data);
    // }

    useEffect(() => {
        //console.log("width, height-", width, height);
        //console.log("attr_id:",attr_id);
        // if(attr_id != undefined && attr_id != null)
        //     setUserId(attr_id);

        setMetaTagData({
            "APP_TITLE":constants.APP_TITLE,
            "APP_DESCRIPTION":constants.APP_DESCRIPTION,
            "APP_IMAGE":constants.APP_IMAGE
        }); 

    //}, [width, height]);
    }, []);    

    const redirctToAppOrWebsite = () => {
        //isMobile, isAndroid, isIOS, isWinPhone
        //console.log("redirctToAppOrWebsite-",isDesktop, isMobile, isAndroid, isIOS, deviceType, isTablet);
        // var url = constants.APP_WEBSITE_URL;       
        // if((isMobile || isTablet) && isAndroid)
        // {
        //     url = constants.APP_GOOGLE_PLAY_URL;
        // }
        // else if((isMobile || isTablet) && isIOS)
        // {
        //     url = constants.APP_APPLE_APP_STORE_URL;
        // }             
        // //console.log("redirctToAppOrWebsite-",url);   
        // //window.open(url);
        // window.location.replace(url);

        openAppOrStore();
    }    
      
    var setFetchedPostData = async (postDataReversed) => {
        //console.log("setFetchedPostData ", postDataReversed);

        //console.log("resfreshAllowed ", resfreshAllowed);
        
        // check user blocked/deleted/de-active
        if(
            resfreshAllowed == 1 
        ) 
        {
            var postData = (postDataReversed && postDataReversed[0])?postDataReversed[0]:null;
            //console.log("postData ", postData);
            var User_Status = postData?.User_Status;
            var Block_Status = postData?.Block_Status;    
            //console.log("User_Status ", User_Status);
            //console.log("Block_Status ", Block_Status);
            if(
                (User_Status != undefined && User_Status == "1")  //user deleted/deactive
                || 
                (Block_Status != undefined && Block_Status != "0") //user blocked
            )
            {        
                // do redirect to website/app/app store
                redirctToAppOrWebsite();
                return;
            } 
        }

        setPostData(postDataReversed);
        // if (postDataReversed[0].Shared_Post_Owner_Name) {
        //     var Creater_Name = postDataReversed[0].Shared_Post_Owner_Name;
        //     var Creater_ProfilePic = postDataReversed[0].Shared_Post_Owner_Thumb_ProfilePic;
        // } else {
        //     var Creater_Name = postDataReversed[0].Creater_Name;
        //     var Creater_ProfilePic = postDataReversed[0].Creater_Thumb_ProfilePic;
        // }   

        

        // postCreatorInfo.Creater_ProfilePic
        // Creater_Name User_Handle
        // postCreatorInfo.User_Bio

        var user_title = constants.APP_TITLE;
        var user_description = constants.APP_DESCRIPTION;
        var user_image = constants.APP_IMAGE;

        //user_title = Creater_Name; // + " @ " + constants.APP_TITLE;

        // if(!(!User_Bio || User_Bio.length === 0 ))
        // {
        //     //user_description = decodeURIComponent(User_Bio);
        // }

        // if(!(!Creater_ProfilePic || Creater_ProfilePic.length === 0 ))
        // {
        //     user_image = Creater_ProfilePic;
        // }      
        
        // console.log({
        //     "APP_TITLE":user_title,
        //     "APP_DESCRIPTION":user_description,
        //     "APP_IMAGE":user_image
        // });

        //setLocalStorage('DL_Meta_Data', postData.Meta_Data, 24 * 60 * 60);

        var dl_data = getLocalStorage("DL_Meta_Data");

        var Meta_Title = dl_data?.Meta_Title || user_title;
        var Meta_Image = dl_data?.Meta_Image || user_image;
        var Meta_Description = dl_data?.Meta_Description || user_description;        

        setMetaTagData({
            "APP_TITLE":Meta_Title,
            "APP_DESCRIPTION":Meta_Description,
            "APP_IMAGE":Meta_Image
        });  
        
        
        //handleDataToParent({ Creater_Name: Meta_Title, Creater_ProfilePic: Meta_Image });

        // console.log({
        //     "APP_TITLE":Meta_Title,
        //     "APP_DESCRIPTION":Meta_Description,
        //     "APP_IMAGE":Meta_Image
        // });

        setIsActive(false);  // Loader false

        if(resfreshAllowed == 1)
        {
            window.parent.postMessage({ action: "hideLoader" }, "*");
        }

        //localStorageTTL, getLocalStorage, setLocalStorage

        setLocalStorage('post_data', postDataReversed, localStorageTTL);

    }

    var noPosts = async () => {
        setIsActive(false);  // Loader false

        if(resfreshAllowed == 1)
        {
            window.parent.postMessage({ action: "hideLoader" }, "*");
        }
    }

    var getPostDataNew = async () => {
        try {
            // console.log("-----getPostData--------------------------");
            // console.log(constants);
            // console.log(process.env);
            // var body = {
            //     "User_TokenKey": attr_id
            // }
            // await fetch(constants.API_BASE_URL + constants.userPostList, {
            //     method: 'POST',
            //     body: JSON.stringify(body),
            //     title: title,
            //     reqId: Math.random().toString(36).slice(2),
            //     headers: {
            //         'Content-type': 'application/json; charset=UTF-8',
            //     },
            //     mode: "cors", // required in frontend
            // })
            // .then((response) => response.json())
            // .then((data) => {             
                
            //setLocalStorage('DL_Post_List', postData.Post_List, localStorageTTL);
            //var data = getLocalStorage("DL_Post_List");

                var d = 0;             
                // if(data.status && data.code == 200)
                // {
                    //var postData = data.data;
                    var postData = getLocalStorage("DL_Post_List");

                    //console.log("getPostDataNew-postData", postData);

                    if(postData != undefined && postData != null && postData.length >0)
                    {
                        d = 1;
                        postData.forEach(item => {

                            try{

                                if (item.Creater_Thumb_ProfilePic) {
                                    item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }
                                if (item.Kudos_User_Thumb_Pic) {
                                    item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }

                                if (item.Shared_Post_Owner_Thumb_ProfilePic) {
                                    item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }

                                if (item.Shared_Post_Owner_ProfilePic) {
                                    item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }
                                //console.log("item.Engagement_User_Paths", item.Engagement_User_Paths);
                                // item.Media_FilePath
                                if (item.Engagement_User_Paths && item.Engagement_User_Paths != null && Array.isArray(item.Engagement_User_Paths) && item.Engagement_User_Paths.length > 0) {
                                    item.Engagement_User_Paths = item.Engagement_User_Paths.map(mediaItem => {
                                        if (mediaItem.Kudos_User_Thumb_Pic) {
                                            mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                                'com/unsafe//',
                                                'com/unsafe/'
                                            );
                                            mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                                constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                                constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                            );
                                            mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                                constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                                constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                            );
                                        }
                                        return mediaItem;
                                    });
                                }

                                // todo in post media check if media type null or ""/blank
                                // then do update
                                // var postMedia = post.Media_FilePath;

                                if (item.Media_FilePath && Array.isArray(item.Media_FilePath) && item.Media_FilePath.length > 0) {
                                    item.Media_FilePath = item.Media_FilePath.map(mediaItem => {
                                        if (mediaItem.Media_Type == "") {
                                            var Media_FilePath = mediaItem.Media_FilePath;
                                            var img_type = Media_FilePath.split('.').pop().toLowerCase();
                                            switch(img_type) {
                                                case 'jpg':
                                                case 'jpeg':
                                                case 'png':
                                                case 'gif':
                                                    // code block
                                                    mediaItem.Media_Type = "0";
                                                    break;                                                
                                                case 'mp4':
                                                case 'm3u8':
                                                    // code block
                                                    mediaItem.Media_Type = "2";
                                                    break;

                                                default:
                                                    // code block
                                                    mediaItem.Media_Type = "0";
                                            }                                        
                                        }
                                        return mediaItem;
                                    });
                                } 
                                else if (typeof item.Media_FilePath === "string")
                                {
                                    console.log("item.Media_FilePath", item.Media_FilePath);
                                }    
                            } 
                            catch(err)
                            {
                                console.log("postData.forEach-err", err);
                            }
                            // foreach loop end
                        });
                        //console.log("getPostData-postData-", postData);
                        //const postDataReversed = postData.reverse();  
                        //const postDataReversed = shuffleArray(postData);  
                        const postDataReversed = postData;   
                                          
                        setFetchedPostData(postDataReversed);

                        return postDataReversed;
                    }
                //}   
                if(d == 0)
                {
                    noPosts();
                }                 
            // })
            // .catch((error) => {
            //     console.log("PostList-getPostData-",error);
            //     noPosts();
            // });
        }
        catch (e) {
            console.log("e ", e)
            setPostData([])
        }
        return [];
    }

    var getPostData = async (title, body) => {
        try {
            // console.log("-----getPostData--------------------------");
            // console.log(constants);
            // console.log(process.env);
            var body = {
                "User_TokenKey": attr_id
            }
            await fetch(constants.API_BASE_URL + constants.userPostList, {
                method: 'POST',
                body: JSON.stringify(body),
                title: title,
                reqId: Math.random().toString(36).slice(2),
                headers: {
                    'Content-type': 'application/json; charset=UTF-8',
                },
                mode: "cors", // required in frontend
            })
            .then((response) => response.json())
            .then((data) => {   
                var d = 0;             
                if(data.status && data.code == 200)
                {
                    var postData = data.data;
                    if(postData != undefined && postData != null && postData.length >0)
                    {
                        d = 1;
                        postData.forEach(item => {
                            if (item.Creater_Thumb_ProfilePic) {
                                item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }
                            if (item.Kudos_User_Thumb_Pic) {
                                item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }

                            if (item.Shared_Post_Owner_Thumb_ProfilePic) {
                                item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }

                            if (item.Shared_Post_Owner_ProfilePic) {
                                item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }

                            if (item.Engagement_User_Paths && item.Engagement_User_Paths.length > 0) {
                                item.Engagement_User_Paths = item.Engagement_User_Paths.map(mediaItem => {
                                    if (mediaItem.Kudos_User_Thumb_Pic) {
                                        mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                            'com/unsafe//',
                                            'com/unsafe/'
                                        );
                                        mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                            constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                            constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                        );
                                        mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                            constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                            constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                        );
                                    }
                                    return mediaItem;
                                });
                            }

                            // todo in post media check if media type null or ""/blank
                            // then do update
                            // var postMedia = post.Media_FilePath;

                            if (item.Media_FilePath && item.Media_FilePath.length > 0) {
                                item.Media_FilePath = item.Media_FilePath.map(mediaItem => {
                                    if (mediaItem.Media_Type == "") {
                                        var Media_FilePath = mediaItem.Media_FilePath;
                                        var img_type = Media_FilePath.split('.').pop().toLowerCase();
                                        switch(img_type) {
                                            case 'jpg':
                                            case 'jpeg':
                                            case 'png':
                                            case 'gif':
                                                // code block
                                                mediaItem.Media_Type = "0";
                                                break;                                                
                                            case 'mp4':
                                            case 'm3u8':
                                                // code block
                                                mediaItem.Media_Type = "2";
                                                break;

                                            default:
                                                // code block
                                                mediaItem.Media_Type = "0";
                                        }                                        
                                    }
                                    return mediaItem;
                                });
                            }                            

                        });
                        //console.log("getPostData-postData-", postData);
                        //const postDataReversed = postData.reverse();  
                        //const postDataReversed = shuffleArray(postData);  
                        const postDataReversed = postData;                     
                        setFetchedPostData(postDataReversed);
                    }
                }   
                if(d == 0)
                {
                    noPosts();
                }                 
            })
            .catch((error) => {
                console.log("PostList-getPostData-",error);
                noPosts();
            });
        }
        catch (e) {
            console.log("e ", e)
            setPostData([])
        }
    }
    // top- 85 left- 0 bottom- 409.3984375 right- 360 innerHeight- 668 innerWidth- 360
    // top- 282.68182373046875 left- 0 bottom- 856.0454711914062 right- 393.0909118652344 innerHeight- 746 innerWidth- 393
    const elementIsVisibleInViewport = (el, partiallyVisible = false) => {
        //console.log("elementIsVisibleInViewport-",el, partiallyVisible);
        if(el == undefined) return false;
        const { top, left, bottom, right } = el.getBoundingClientRect();
        const { innerHeight, innerWidth } = window;
        //console.log("top-",top, "left-",left, "bottom-",bottom, "right-",right, "innerHeight-",innerHeight, "innerWidth-",innerWidth);
        return partiallyVisible
          ? ((top >= 0 && top < innerHeight) || (bottom > 0 && (bottom-1) <= innerHeight)) &&
              ((left >= 0 && left < innerWidth) || (right > 0 && (right-1) <= innerWidth))
          : top >= 0 && left >= 0 && (bottom-1) <= innerHeight && (right-1) <= innerWidth;
    };
      
    //   // e.g. 100x100 viewport and a 10x10px element at position
    //   // {top: -1, left: 0, bottom: 9, right: 10}
    //   elementIsVisibleInViewport(el); // false - (not fully visible)
    //   elementIsVisibleInViewport(el, true); // true - (partially visible)

    const handleRefresh = () => {
        ///console.log("handleRefresh-");
        // var body = {
        //     "User_TokenKey": attr_id
        // }
        // return handleRefreshNew("Post Details", body);

        return handleRefreshNewAPI();

        //console.log("handleRefresh-2");
    };

    const onRefreshNew = () => {
        //console.log("onRefreshNew Simulates a delay of 2 seconds-1");
        return new Promise((resolve) => {
            //console.log("onRefreshNew Simulates a delay of 2 seconds-2");
            setTimeout(() => {
                //console.log("onRefreshNew Simulates a delay of 2 seconds-2-resolve");
                resolve();
                //console.log("onRefreshNew Simulates a delay of 2 seconds-3-resolve-after");
            //}, 2000); // Simulates a delay of 2 seconds
            }, 100); // Simulates a delay of 1 seconds
            //console.log("onRefreshNew Simulates a delay of 2 seconds-2------------------2-");
        });
        //console.log("onRefreshNew Simulates a delay of 2 seconds-2-------------1-");
    };

    const handleRefreshNewAPI = () => {
        //console.log("handleRefreshNew-1");
        return onRefreshNew()
            .then(() => {
                //console.log("handleRefreshNew-2");
                //return fetch('https://jsonplaceholder.typicode.com/posts/1'); // Example API
                // return fetch(constants.API_BASE_URL + constants.userPostList, {
                //     method: 'POST',
                //     body: JSON.stringify(body),
                //     title: title,
                //     reqId: Math.random().toString(36).slice(2),
                //     headers: {
                //         'Content-type': 'application/json; charset=UTF-8',
                //     },
                // });

                 var body = {
                     "Deep_Link_URI": constants.APP_DEEP_LINK_BASE_URL + window.location.pathname,
                     "RequestType": "1"
                 }            
     
                 return fetch(constants.API_BASE_URL + "webviewData", {
                     method: 'POST',
                     body: JSON.stringify(body),
                     //title: title,
                     reqId: Math.random().toString(36).slice(2),
                     headers: {
                         'Content-type': 'application/json; charset=UTF-8',
                     },
                     mode: "cors", // required in frontend
                 })             
            })
            .then((response) => {
                //console.log("handleRefreshNew-3");
                //console.log(response);
                if (!response.ok) {
                    console.error('Network response was not ok');
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                //console.log("handleRefreshNew-4");
                //console.log(data);
                //setData(data);
                //setLoading(false);
                var d = 0;             
                //if(data.status && data.code == 200)
                if(data.code == 200 && data.data != undefined && util_isObjectNotEmpty(data.data))
                {
                    setLocalStorage('Video_Audio_Mute_Msg_data', data.Video_Audio_Mute_Msg, 24 * 60 * 60);
                    var postData = data.data.Post_List;
                    setLocalStorage('DL_Post_List', data.data.Post_List, 24 * 60 * 60);
                    if(postData != undefined && postData != null && postData.length >0)
                    {
                        d = 1;
                        postData.forEach(item => {
                            try{
                                if (item.Creater_Thumb_ProfilePic) {
                                    item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }
                                if (item.Kudos_User_Thumb_Pic) {
                                    item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }

                                if (item.Shared_Post_Owner_Thumb_ProfilePic) {
                                    item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }

                                if (item.Shared_Post_Owner_ProfilePic) {
                                    item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                        'com/unsafe//',
                                        'com/unsafe/'
                                    );
                                    item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                        constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                    item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                        constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                        constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                    );
                                }

                                if (item.Engagement_User_Paths && item.Engagement_User_Paths != null && Array.isArray(item.Engagement_User_Paths) && item.Engagement_User_Paths.length > 0) {
                                    item.Engagement_User_Paths = item.Engagement_User_Paths.map(mediaItem => {
                                        if (mediaItem.Kudos_User_Thumb_Pic) {
                                            mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                                'com/unsafe//',
                                                'com/unsafe/'
                                            );
                                            mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                                constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                                constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                            );
                                            mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                                constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                                constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                            );
                                        }
                                        return mediaItem;
                                    });
                                }

                                if (item.Media_FilePath && Array.isArray(item.Media_FilePath) && item.Media_FilePath.length > 0) {
                                    item.Media_FilePath = item.Media_FilePath.map(mediaItem => {
                                        if (mediaItem.Media_Type == "") {
                                            var Media_FilePath = mediaItem.Media_FilePath;
                                            var img_type = Media_FilePath.split('.').pop().toLowerCase();
                                            switch(img_type) {
                                                case 'jpg':
                                                case 'jpeg':
                                                case 'png':
                                                case 'gif':
                                                    // code block
                                                    mediaItem.Media_Type = "0";
                                                    break;                                                
                                                case 'mp4':
                                                case 'm3u8':
                                                    // code block
                                                    mediaItem.Media_Type = "2";
                                                    break;

                                                default:
                                                    // code block
                                                    mediaItem.Media_Type = "0";
                                            }                                        
                                        }
                                        return mediaItem;
                                    });
                                } 
                                else if (typeof item.Media_FilePath === "string")
                                {
                                    console.log("item.Media_FilePath", item.Media_FilePath);
                                }                                
                            } 
                            catch(err)
                            {
                                console.log("postData.forEach-err", err);
                            }
                            // foreach loop end                                                         
                        });
                        //console.log("handleRefreshNew-postData-", postData);
                        //const postDataReversed = postData.reverse();  
                        //const postDataReversed = shuffleArray(postData);  
                        const postDataReversed = postData;                     
                        setFetchedPostData(postDataReversed);
                    }
                }   
                if(d == 0)
                {
                    noPosts();
                }
            })
            .catch((error) => {
                //setError(error.message);
                //setLoading(false);
                // console.log("handleRefreshNew-error-5");
                // console.log("Refresh-PostList-getPostData-",error.message);
                // console.log(error);
                noPosts();
            });
    };    
    
    const handleRefreshNewOld = (title, body) => {
        //console.log("handleRefreshNew-1");
        return onRefreshNew()
            .then(() => {
                //console.log("handleRefreshNew-2");
                //return fetch('https://jsonplaceholder.typicode.com/posts/1'); // Example API
                return fetch(constants.API_BASE_URL + constants.userPostList, {
                    method: 'POST',
                    body: JSON.stringify(body),
                    title: title,
                    reqId: Math.random().toString(36).slice(2),
                    headers: {
                        'Content-type': 'application/json; charset=UTF-8',
                    },
                });
            })
            .then((response) => {
                //console.log("handleRefreshNew-3");
                //console.log(response);
                if (!response.ok) {
                    console.error('Network response was not ok');
                    throw new Error('Network response was not ok');
                }
                return response.json();
            })
            .then((data) => {
                //console.log("handleRefreshNew-4");
                //console.log(data);
                //setData(data);
                //setLoading(false);
                var d = 0;             
                if(data.status && data.code == 200)
                {
                    var postData = data.data;
                    if(postData != undefined && postData != null && postData.length >0)
                    {
                        d = 1;
                        postData.forEach(item => {
                            if (item.Creater_Thumb_ProfilePic) {
                                item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Creater_Thumb_ProfilePic = item.Creater_Thumb_ProfilePic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }
                            if (item.Kudos_User_Thumb_Pic) {
                                item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Kudos_User_Thumb_Pic = item.Kudos_User_Thumb_Pic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }

                            if (item.Shared_Post_Owner_Thumb_ProfilePic) {
                                item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Shared_Post_Owner_Thumb_ProfilePic = item.Shared_Post_Owner_Thumb_ProfilePic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }

                            if (item.Shared_Post_Owner_ProfilePic) {
                                item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                    'com/unsafe//',
                                    'com/unsafe/'
                                );
                                item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                    constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                                item.Shared_Post_Owner_ProfilePic = item.Shared_Post_Owner_ProfilePic.replace(
                                    constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                    constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                );
                            }

                            if (item.Engagement_User_Paths && item.Engagement_User_Paths.length > 0) {
                                item.Engagement_User_Paths = item.Engagement_User_Paths.map(mediaItem => {
                                    if (mediaItem.Kudos_User_Thumb_Pic) {
                                        mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                            'com/unsafe//',
                                            'com/unsafe/'
                                        );
                                        mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                            constants.APP_BASE_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                            constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                        );
                                        mediaItem.Kudos_User_Thumb_Pic = mediaItem.Kudos_User_Thumb_Pic.replace(
                                            constants.APP_CDN_URL+'images/users/profilepics/placeholder_image_50X50.png',
                                            constants.APP_CDN_URL+'images/admin_images/users/profilepics/placeholder_image_50X50.png'
                                        );
                                    }
                                    return mediaItem;
                                });
                            }
                                                        
                        });
                        //console.log("handleRefreshNew-postData-", postData);
                        //const postDataReversed = postData.reverse();  
                        //const postDataReversed = shuffleArray(postData);  
                        const postDataReversed = postData;                     
                        setFetchedPostData(postDataReversed);
                    }
                }   
                if(d == 0)
                {
                    noPosts();
                }
            })
            .catch((error) => {
                //setError(error.message);
                //setLoading(false);
                // console.log("handleRefreshNew-error-5");
                // console.log("Refresh-PostList-getPostData-",error.message);
                // console.log(error);
                noPosts();
            });
    };    
   

    useEffect(() => {
        let totalPosts = 0;
        if (!initialized.current) {
            initialized.current = true;            

            if(window.location.hostname == 'localhost' && 1==0)
            {
                var postDataReversed = getLocalStorage('post_data');
          
                if(postDataReversed == null)
                {
                    //getPostData("Post Details", {}); 
                    totalPosts = getPostDataNew();
                }
                else
                {
                    setFetchedPostData(postDataReversed);
                }  
            }
            else
            {
                //getPostData("Post Details", {}); 
                totalPosts = getPostDataNew();
            }         
        }
            
        // window.addEventListener('scroll', handleScroll, { passive: true });

        // window.addEventListener('scroll', () => {
        //     console.log("scroll-CommonScrollUtils.isLocked,CommonScrollUtils.isRestoringScroll", CommonScrollUtils.isLocked, CommonScrollUtils.isRestoringScroll, CommonScrollUtils.scrollYiOS, window.scrollY);
        //     CommonScrollUtils.handleScrollEvent(handleScroll);
        // });



        // window.addEventListener('scrollend', handleScrollEnd, { passive: true });

        return () => { 
            // window.removeEventListener('scroll', handleScroll);
            // window.removeEventListener('scrollend', handleScrollEnd);
        };            

    }, []);

    function DateFormater(date) {
        if (date) {
            var today = new Date(date);
            var ye = new Intl.DateTimeFormat("en", { year: "numeric" }).format(today);
            var mo = new Intl.DateTimeFormat("en", { month: "short" }).format(today);
            var da = new Intl.DateTimeFormat("en", { day: "2-digit" }).format(today);
            var Post_Date = da + " " + mo + " " + ye
        } else {
            var Post_Date = "";
        }
        return Post_Date;
    }

    function postTimeView(date) {
        let post_time = "";
        // moment.utc(time).local()
        //var post_time2 = moment.utc(date).local().fromNow(); //eg. 1 day, 2 hours
        // days, hours, minutes, and seconds
        var b = moment.utc(date).local();
        var a = moment();
        var days = a.diff(b, 'days'); // days
        var hours = a.diff(b, 'hours'); // hours
        var minutes = a.diff(b, 'minutes'); // minutes
        var seconds = a.diff(b, 'seconds'); // seconds

        days = parseInt(days);
        hours = parseInt(hours);
        minutes = parseInt(minutes);
        seconds = parseInt(seconds);

        if (seconds <= 59) {
            post_time = "Just now";
        } else if (minutes == 1) {
            post_time = (minutes) + " min ago";            
        } else if (minutes > 1 && minutes <= 59) {
            post_time = (minutes) + " mins ago";
        } else if (hours == 1) {
            post_time = (hours) + " hour ago";             
        } else if (hours > 1 && hours <= 24) {
            post_time = (hours) + " hours ago";  
        } else if (days == 1) {
            post_time = (days) + " day ago";                     
        } else if (days > 1 && days <= 6) {
            post_time = (days) + " days ago";
        } else {
            post_time = DateFormater(date);
        }

        //console.log("post_time-",post_time, "post_time2-",post_time2, "days-",days, "hours-",hours, "minutes-",minutes, "seconds-",seconds);

        return post_time;
    }

    function postTimeViewBucket(date) {

        //console.log("postTimeViewBucket-date", date);
        let post_time = "";
        // moment.utc(time).local()
        var post_time2 = moment.utc(date, "YYYY-MM-DD HH:mm:ss").local().fromNow(); //eg. 1 day, 2 hours
        // years, months, weeks, days, hours, minutes, and seconds
        var b = moment.utc(date, "YYYY-MM-DD HH:mm:ss").local();
        var a = moment();
        var months = a.diff(b, 'months'); // months
        var days = a.diff(b, 'days'); // days
        var hours = a.diff(b, 'hours'); // hours
        var minutes = a.diff(b, 'minutes'); // minutes
        var seconds = a.diff(b, 'seconds'); // seconds

        //console.log("post_time2-",post_time2, "days-",days, "hours-",hours, "minutes-",minutes, "seconds-",seconds);

        months = parseInt(months);
        days = parseInt(days);
        hours = parseInt(hours);
        minutes = parseInt(minutes);
        seconds = parseInt(seconds);

        if (seconds <= 59) {
            //post_time = "Just now";
            post_time = post_time2;
        } else if (minutes == 1) {
            //post_time = (minutes) + " min ago";
            post_time = post_time2;            
        } else if (minutes > 1 && minutes <= 59) {
            //post_time = (minutes) + " mins ago";
            post_time = post_time2;
        } else if (hours == 1) {
            //post_time = (hours) + " hour ago"; 
            post_time = post_time2;            
        } else if (hours > 1 && hours <= 24) {
            //post_time = (hours) + " hours ago";
            post_time = post_time2;  
        } else if (days == 1) {
            //post_time = (days) + " day ago";
            post_time = post_time2;
        } else if (days > 1 && days <= 30) {
            //post_time = (days) + " days ago";
            post_time = post_time2;
        } else if (months == 1) {
            //post_time = (months) + " month ago";
            post_time = post_time2;
        } else if (months > 1 && months <= 12) {
            //post_time = (months) + " months ago"; 
            post_time = post_time2;           
        } else {
            post_time = DateFormater(date);
        }

        //console.log("post_time-",post_time, "post_time2-",post_time2, "days-",days, "hours-",hours, "minutes-",minutes, "seconds-",seconds);

        return post_time;
    }    

    function postTimeViewUpdated(post) {
        let post_time = "";

        if(post.Post_Updated_Status == "0")
            return (<></>);

        let date = post.Updated_DateTime;

        var today = new Date();
        var localoffset = (today.getTimezoneOffset() / 60);
        var dz1 = new Date(new Date(date).getTime());
        var dz2 = new Date(new Date().getTime());
        let post_diff = Math.abs(dz2.getTime() - dz1.getTime()); // milliseconds 
        let pt = parseInt(post_diff / (1000 * 60 * 60 * 24)); // days
        let pt_hour = parseInt(post_diff / (1000 * 60 * 60)) + localoffset; 
        let pt_min = parseInt(post_diff / (1000 * 60)) + (localoffset * 60);
        let pt_sec = parseInt(post_diff / 1000) + (localoffset * 60 * 60);
        if (pt_sec <= 59) {
            post_time = "Just now";
        } else if (pt_min >= 1 && pt_min <= 59) {
            post_time = parseInt(pt_min) + " min ago";
        } else if (pt_hour >= 1 && pt_hour <= 24) {
            post_time = parseInt(pt_hour) + " hour ago";
        } else if (pt <= 6) {
            post_time = parseInt(pt) + " day ago";
        } else {
            post_time = DateFormater(date);
        }
        //console.log("post_diff-",post_diff,"pt-",pt,"pt_hour-",pt_hour,"pt_min-",pt_min,"pt_sec-",pt_sec);
        //console.log("post_time-",post_time);
        //return post_time
 
        return(<>
            <span className="date-color time-dot"></span>
            <span className="date-color"> Updated {(post_time)}</span>             
        </>);
        
    } 
    
    function NewPostStringWithInfo(post){

        var newPostStringFlag = false;

        if(post.Post_String_Info != undefined 
            && post.Post_String_Info != null
            && post.Post_String_Info.Post_String != undefined 
            && post.Post_String_Info.Post_String != null
        )
        {  

            // "Post_String": "will1 go to {TO_PLACE_NAME} on {TRAVEL_DATE} with1 {TAG_PEOPLE}",
            // "Post_String2": "was to be at {TO_PLACE_NAME} on {TRAVEL_DATE}",

            // console.log("NewPostStringWithInfo", post.Post_String, post.Post_String2);
            // console.log("NewPostStringWithInfo", post.Post_String_Info, post);

            newPostStringFlag = true;
            var pst = post.Post_String_Info.Post_String;
            //console.log("pst", pst);

            if(
                post.Post_String_Info.Post_String2 != undefined 
                && post.Post_String_Info.Post_String2 != null
            )
            {
                // Future_Travel_Date: "2025-08-23 11:50:52"
                // post.Future_Travel_Date

                // Parse as UTC
                const givenFuture_Travel_Date = moment.utc(post.Future_Travel_Date, "YYYY-MM-DD HH:mm:ss");

                // Current local time
                const nowLocalTodayDate = moment();

                // Compare
                if (givenFuture_Travel_Date.isBefore(nowLocalTodayDate)) {
                    pst = post.Post_String_Info.Post_String2;
                }

                //console.log("pst", pst);

            }


            if(post.Post_String_Info.Click_Events != undefined 
                && post.Post_String_Info.Click_Events != null
                && post.Post_String_Info.Click_Events.length >0
            )
            { 
                // Event_Name: "{TO_PLACE_NAME}"
                // Event_Value: "Anytime Fitness"
                post.Post_String_Info.Click_Events.forEach(Click_Event => {

                    // TRAVEL_DATE

                    if(Click_Event.Event_Name.includes("{TRAVEL_DATE}"))
                    {
                        // {TRAVEL_DATE}
                        // Parse as UTC
                        //const givenTRAVEL_DATE = moment.utc(Click_Event.Event_Value, "YYYY-MM-DD HH:mm:ss").local().format(""DD MMM YYYY"");
                        // DateFormater(post.Future_Travel_Date)
                        pst = pst.replaceAll(Click_Event.Event_Name, "<b>" + DateFormater(Click_Event.Event_Value) + "</b>");

                    }
                    else
                    {
                        pst = pst.replaceAll(Click_Event.Event_Name, "<b>" + Click_Event.Event_Value + "</b>");
                    }


                    
                    //pst = pst.replaceAll(Click_Event.Event_Name, "");
                });
            }
            pst = pst.replace("New1", "New");
            pst = pst.replace("Explurging1", "Explurging");
            pst = pst.replace("spread1", "spread");
            //console.log("pst", pst);

            return (<>
                {ReactHtmlParser(pst)}
                <br></br>
            </>)            
        }        


        if(newPostStringFlag !== true)
        {
            // Alog with
            if (post.Tagged_User_Name) {
                var Post_Tagged_Text = " along with ";
            } else {
                var Post_Tagged_Text = "";
            }

            //"Post_Type": "5", // Says
            // Post_Type: "1" // added 6 Images & 3 Videos

            if(post.Post_Type == "1" || post.Post_Type == "5" ){
                return (<></>);
            }

            return (<>
                <span className="postString">{postString3(post)}</span>
                <span className="placeName"><b> {post.To_PlaceName}</b></span>
                <span className='placeName'>{FutureTravelDateView(post)}</span>
                <span className='placeName'>{postString2(post)}</span>
                
                <span className='placeName'>{Post_Tagged_Text}</span>
                <span className='tagedText'><b> {post.Tagged_User_Name}</b></span>
                <br></br>                
            </>);
        }

    }

    // postData.Post_Type == "2"
    function postString2(post) {
        if (post.Post_Type == "2") {
            return (<>
                <span> from <b>{post.From_PlaceName}</b> by <b>{post.User_Travel_By}</b></span>
            </>)
        }
    }

    function postString3(post) {

        // console.log("postString3", post.Post_String, post.Post_String2);
        // console.log("postString3", post.Post_String_Info, post);

        //return (<></>);

        var pt = post.Post_String2.toString();

        // Post_Type : "7"
        if (post.Post_Type == constants.POST_TYPE_PROFILE_PIC_STR) {
            return (<>
                {/* <b>{post.Post_String2}</b>  */}
                {post.Post_String}
            </>)
        }
        // Post_Type : "6"
        else if (post.Post_Type == constants.POST_TYPE_SPREAD_STR) 
        {
            // Spread_Type : "6"
            // Spread_Type : "4"
            if (post.Spread_Type == constants.POST_SPREAD_TYPE_KUDOS || post.Spread_Type == constants.POST_SPREAD_TYPE_CITY)
            {                
                var psts = post.Post_String2.toString().split(',');
                for(var i=0; i<psts.length;i++)
                {
                    pt = pt.replace(psts[i].toString(), "<b>" + psts[i].toString() + "</b>");
                }
                return (<>
                    {ReactHtmlParser(pt)}
                </>)
            } 
            // // Spread_Type : "7"
            // else if (post.Spread_Type == constants.POST_SPREAD_TYPE_FELLOW)
            // {

            // }
            // Spread_Type : "8"
            else if (post.Spread_Type == constants.POST_SPREAD_TYPE_EXPLURGER_LEVEL)
            {
                // Post_String                :                 "is now on Cobalt Level"
                // Post_String2                :                 "Explurger Level Summery"
                var pt1 = pt.replace('is now on', '').trim(); 
                pt = 'is now on ' + "<b>" + pt1 + "</b>";
                return (<>
                    {ReactHtmlParser(pt)}
                </>)                
            }
            //Spread_Type : "0"
            else if (post.Spread_Type == constants.POST_SPREAD_TYPE_EXPLURGER)
            {
                // Post_String                :                 "has spread Explurger Journey So Far"
                // Post_String2                :                 ""
                var pt1 = pt.replace('has Explurged', '').trim(); 
                pt = 'Explurged ' + "<b>" + pt1 + "</b>";
                return (<>
                    {ReactHtmlParser(pt)}
                </>)                
            }            
            else
            {
                return (<>
                    {post.Post_String}
                </>)                
            }
        }
        // // Post_Type : "2"
        // else if (post.Post_Type == constants.POST_TYPE_TRAVELLING_STR) 
        // {

        // }
        else
        {
            if(post.Post_Type == "3")
            {
                // Future_Travel_Date: "2025-08-23 11:50:52"

                // Parse as UTC
                const given = moment.utc(post.Future_Travel_Date, "YYYY-MM-DD HH:mm:ss");

                // Current local time
                const nowLocal = moment();

                // Compare
                if (given.isBefore(nowLocal)) {
                    //console.log("Given UTC time is older than current local time.");
                    //return(<></>);
                    var Post_String_Info_Post_String2 = post.Post_String_Info.Post_String2;
                    //console.log("------7-Post_String_Info_Post_String2:", Post_String_Info_Post_String2);
                    Post_String_Info_Post_String2 = Post_String_Info_Post_String2.replace("{TO_PLACE_NAME} on {TRAVEL_DATE}", '');
                    //console.log("------7-Post_String_Info_Post_String2:", Post_String_Info_Post_String2);
                    // Post_String2: "was to be at {TO_PLACE_NAME} on {TRAVEL_DATE}"
                    return (<>
                        {/* <b>{post.Post_String2}</b>*/}
                        {Post_String_Info_Post_String2}
                    </>)
                } else {
                    //console.log("Given UTC time is NOT older.");
                } 
            }           

            return (<>
                {/* <b>{post.Post_String2}</b>*/}
                {post.Post_String}
            </>)
        }
        //*/
    }

    function FutureTravelDateView(post) {
        // console.log("FutureTravelDateView ", post.Future_Travel_Date)
        if (post.Future_Travel_Date && post.Future_Travel_Date != "0000-00-00 00:00:00") {
            return (<> on <b> {DateFormater(post.Future_Travel_Date)}</b></>)
        }
    }

    const postProfileView = (post) => {
        // Badge icon
        var badgeImg = "";
        var Badge_Img = "";
        if (post.Profile_Type == "1" && post.Badge_Status == "1") {
            badgeImg = business_badge
            Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        } else if ((post.Profile_Type == "0" || post.Profile_Type == "2") && post.Badge_Status == "1") {
            badgeImg = verified_icon
            Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        } 

        // Alog with
        if (post.Tagged_User_Name) {
            var Post_Tagged_Text = " along with ";
        } else {
            var Post_Tagged_Text = "";
        }

        if (post.Post_Shared == "0") {
            return (<>
                <div className="row">
                    <div className="col-sm-1 img_data" onClick={clickCenterModalOpen}>
                        <img className="circle_profile_small" 
                            src={post.Creater_Thumb_ProfilePic} 
                            alt="image_profile"></img>
                    </div>
                    <div className="col-sm-10 data-match" onClick={clickCenterModalOpen}>
                        <span className="data_left">
                            <strong>{post.Creater_Name}&nbsp;</strong>
                            {Badge_Img}
                        </span>
                        <span > ({post.Miles_Explurged} Miles <img className='milesImg' src={MILES_URL}></img>)</span>
                        <br></br>
                        {/* <span className="postString">{postString3(post)}</span>
                        <span className="placeName"><b> {post.To_PlaceName}</b></span>
                        <span className='placeName'>{FutureTravelDateView(post)}</span>
                        <span className='placeName'>{postString2(post)}</span> */}

                        {NewPostStringWithInfo(post)}

                        {/* <span className='placeName'>{Post_Tagged_Text}</span>
                        <span className='tagedText'><b> {post.Tagged_User_Name}</b></span> */}
                        {/* <br></br> */}
                        {/* <span className="date-color">{DateFormater(post.Created_DateTime)}</span> */}
                        <span className="date-color">{postTimeView(post.Created_DateTime)}</span>

                        {/* {postTimeViewUpdated(post)} */}

                    </div>
                    <div className="col-sm-1 data-match-dot-dot" onClick={clickCenterModalOpen}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </>)
        } else if (post.Post_Shared == "1") {
            {/* spreaded profile */ }
            return (<>
                <div className="row">
                    <div className="col-sm-1 img_data" onClick={clickCenterModalOpen}>
                        <img className="circle_profile_small" 
                            src={constants.APP_CDN_URL + post.Shared_Post_Owner_ProfilePic} 
                            alt="image_profile"></img>
                    </div>
                    <div className="col-sm-10  data-match" onClick={clickCenterModalOpen}>
                        <span className="data_left">
                            <strong> {post.Shared_Post_Owner_Name}&nbsp;</strong>
                            {Badge_Img}
                            spread this
                        </span>
                        {/* <span > ({post.Shared_User_Miles_Explurge} Miles <img className='milesImg' src={MILES_URL}></img>)</span> */}

                        {/* <br></br> */}
                        {/* <span className="date-color">{DateFormater(post.Shared_Post_Created_DateTime)}</span> */}
                        <span className="date-color"> {postTimeView(post.Shared_Post_Created_DateTime)} </span>
                        {/* {postTimeViewUpdated(post)} */}
                    </div>
                    <div className="col-sm-1 data-match-dot-dot" onClick={clickCenterModalOpen}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
                <div className="row postWoner">
                    <div className="col-sm-1 img_data">
                        <img className="circle_profile_small" 
                            src={post.Creater_Thumb_ProfilePic} 
                            alt="image_profile"></img>                        
                    </div>
                    <div className="col-sm-11  data-match">
                        <span className="data_left">
                            <strong>{post.Creater_Name}&nbsp;</strong>
                            {Badge_Img}
                        </span>
                        <span > ({post.Miles_Explurged} Miles <img className='milesImg' src={MILES_URL}></img>)</span>
                        <br></br>
                        {/* <span className="postString">{post.Post_String}</span>
                        <span className="placeName"><b> {post.To_PlaceName}</b></span>
                        <br></br> */}
                        {NewPostStringWithInfo(post)}
                        {/* <span className="date-color">{DateFormater(post.Created_DateTime)}</span> */}
                        <span className="date-color">{postTimeView(post.Created_DateTime)}</span>
                    </div>
                </div>


            </>)
        } else {
            return (<></>)
        }
    }


    const postProfileView2 = (post,md=0) => {
        // Badge icon
        var badgeImg = "";
        var Badge_Img = "";  
        // console.log("postProfileView2-md", md, post.Post_ID, post.Shared_Post_Parent_ID);
        // console.log("postProfileView2-post.Post_Shared", post.Post_Shared);
        // console.log("postProfileView2-post.Profile_Type", post.Profile_Type);
        // console.log("postProfileView2-post.Shared_Profile_Type", post.Shared_Profile_Type);
        if(md==1) // md=1 for original post owner
        {
            if (post.Profile_Type == "1" && post.Badge_Status == "1") {
                badgeImg = business_badge
                Badge_Img = <img className="badg-verified" src={badgeImg}></img>
            } else if ((post.Profile_Type == "0" || post.Profile_Type == "2") && post.Badge_Status == "1") {
                badgeImg = verified_icon
                Badge_Img = <img className="badg-verified" src={badgeImg}></img>
            } 
        }
        else // md=0 for spread post
        {
            if (post.Shared_Profile_Type == "1" && post.Shared_Badge_Status == "1") {
                badgeImg = business_badge
                Badge_Img = <img className="badg-verified" src={badgeImg}></img>
            } else if ((post.Shared_Profile_Type == "0" || post.Shared_Profile_Type == "2") && post.Shared_Badge_Status == "1") {
                badgeImg = verified_icon
                Badge_Img = <img className="badg-verified" src={badgeImg}></img>
            }
        }
        // if (post.Post_Shared == "0") {      
        //     if (post.Profile_Type == "1" && post.Badge_Status == "1") {
        //         badgeImg = business_badge
        //         Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        //     } else if ((post.Profile_Type == "0" || post.Profile_Type == "2") && post.Badge_Status == "1") {
        //         badgeImg = verified_icon
        //         Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        //     } 
        // }
        // else if (post.Post_Shared == "1") {

        //     // "Profile_Type": "2",
        //     // "Shared_Profile_Type": "2",            
        //     if (post.Shared_Profile_Type == "1" && post.Shared_Badge_Status == "1") {
        //         badgeImg = business_badge
        //         Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        //     } else if ((post.Shared_Profile_Type == "0" || post.Shared_Profile_Type == "2") && post.Shared_Badge_Status == "1") {
        //         badgeImg = verified_icon
        //         Badge_Img = <img className="badg-verified" src={badgeImg}></img>
        //     }            
        // }


        // Alog with
        if (post.Tagged_User_Name) {
            var Post_Tagged_Text = " along with ";
        } else {
            var Post_Tagged_Text = "";
        }

        if (post.Post_Shared == "0") {
            return (<>
                <div className="row">
                    <div className="col-sm-1 img_data" onClick={clickCenterModalOpen}>
                        <img className="circle_profile_small" 
                            src={post.Creater_Thumb_ProfilePic} 
                            alt="image_profile"></img>                        
                    </div>
                    <div className="col-sm-10 data-match" onClick={clickCenterModalOpen}>
                        <span className="data_left">
                            <strong>{post.Creater_Name}&nbsp;</strong>
                            {Badge_Img}
                        </span>
                        <span > ({post.Miles_Explurged} Miles <img className='milesImg' src={MILES_URL}></img>)</span>
                        <br></br>
                        {/* <span className="postString">{postString3(post)}</span>
                        <span className="placeName"><b> {post.To_PlaceName}</b></span>
                        <span className='placeName'>{FutureTravelDateView(post)}</span>
                        <span className='placeName'>{postString2(post)}</span> */}

                        {NewPostStringWithInfo(post)}

                        {/* <span className='placeName'>{Post_Tagged_Text}</span>
                        <span className='tagedText'><b> {post.Tagged_User_Name}</b></span> */}
                        {/* <br></br> */}
                        {/* <span className="date-color">{DateFormater(post.Created_DateTime)}</span> */}
                        <span className="date-color">{postTimeView(post.Created_DateTime)}</span>
                        {/* {postTimeViewUpdated(post)} */}
                    </div>
                    <div className="col-sm-1 data-match-dot-dot" onClick={clickCenterModalOpen}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </>)
        } else if (post.Post_Shared == "1") {
            {/* spreaded profile */ }
            if(md==0)
            {
                return (<>
                    <div className="row">
                        <div className="col-sm-1 img_data" onClick={clickCenterModalOpen}>
                            <img className="circle_profile_small" 
                                src={constants.APP_CDN_URL + post.Shared_Post_Owner_ProfilePic} 
                                alt="image_profile"></img>                            
                        </div>
                        <div className="col-sm-10  data-match" onClick={clickCenterModalOpen}>
                            <span className="data_left"> 
                                <strong> {post.Shared_Post_Owner_Name}&nbsp;</strong>
                                {Badge_Img}
                                spread this
                            </span>
                            {/* <span > ({post.Shared_User_Miles_Explurge} Miles <img className='milesImg' src={MILES_URL}></img>)</span> */}
    
                            {/* <br></br> */}
                            {/* <span className="date-color">{DateFormater(post.Shared_Post_Created_DateTime)}</span> */}
                            <span className="date-color"> {postTimeView(post.Shared_Post_Created_DateTime)} </span>
                            {/* {postTimeViewUpdated(post)} */}
                        </div>
                        <div className="col-sm-1 data-match-dot-dot" onClick={clickCenterModalOpen}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    </div>
                </>)
            }
            else
            {
                // Shared_Post_Parent_ID : "46936"
                return (<>
                    <div className="row postWoner p010">
                        <div className="col-sm-1 img_data">
                            <img className="circle_profile_small" 
                                src={post.Creater_Thumb_ProfilePic} 
                                alt="image_profile"></img>                            
                        </div>
                        <div className="col-sm-11  data-match">
                            <span className="data_left">
                                <strong>{post.Creater_Name}&nbsp;</strong>
                                {Badge_Img}
                            </span>
                            <span > ({post.Miles_Explurged} Miles <img className='milesImg' src={MILES_URL}></img>)</span>
                            <br></br>
                            {/* <span className="postString">{post.Post_String}</span>
                            <span className="placeName"><b> {post.To_PlaceName}</b></span> */}

                            {/* <span className="postString">{postString3(post)}</span>
                            <span className="placeName"><b> {post.To_PlaceName}</b></span>
                            <span className='placeName'>{FutureTravelDateView(post)}</span>
                            <span className='placeName'>{postString2(post)}</span> */}

                            {NewPostStringWithInfo(post)}

                            {/* <span className='placeName'>{Post_Tagged_Text}</span>
                            <span className='tagedText'><b> {post.Tagged_User_Name}</b></span> */}

                            {/* <br></br> */}
                            {/* <span className="date-color">{DateFormater(post.Created_DateTime)}</span> */}
                            <span className="date-color">{postTimeView(post.Created_DateTime)}</span>
                        </div>
                    </div>
                </>)
            }

        } else {
            return (<></>)
        }
    }    

    var urlRegex = /(https?:\/\/[^\s]+)/g;
    const linkRegex = /(https?\:\/\/)?(www\.)?[^\s]+\.[^\s]+/g;
    const linkRegexHttpWww = /http(s)?(:)?(\/\/)?|(\/\/)?(www\.)?/g;
    const hasHashRegex = /(?:^|\W)#(\w+)(?!\w)/g;
    const tagHashRegex = /(?:^|\W)@(\w+)(?!\w)/g;
    const regexNewLineCount = /$/mg;

    function replacer(matched) {
        let withProtocol = matched
        
        if(!withProtocol.startsWith("http")) {
          withProtocol = "http://" + matched
        }
       
        const newStr = `<a className="text-link" href="${withProtocol}" target="_blank" >${matched}</a>`
        
        return newStr;
    }    

    function replacerHttpWww(matched, p1, p2, p3, offset, str) {
        //console.log("matched-",matched, "p1-",p1, "p2-",p2, "p3-",p3, "offset-",offset, "str-",str);       
        return "";
    }

    const postTextView = (post) => {
        if (post.Post_Text) {
            return (<>
                <div className='postText postTextOwnerBox'><ReadMore>{post}</ReadMore></div>
            </>)
        } else {
            return (<></>)
        }
    }

    const postTextViewShared = (post) => {
        //Post_Text  Shared_Post_Text
        if (post.Shared_Post_Text) {
            return (<>
                <div className='postText postTextSharedBox'><ReadMoreShared>{post}</ReadMoreShared></div>
            </>)
        } else {
            return (<></>)
        }
    }    

    const videoClick = slideIndex => event => {
        //console.log("videoClick = ", slideIndex);
    };

    var beforeSlide = (slideIndex, postId, dt=1) => {
        // console.log("ViewPost-beforeSlide = ", slideIndex);
        // console.log("ViewPost-beforeSlide =postId= ", postId);

        //console.log(sliderRef.currentSlide);

        // explr-vid-view
        try {
            const videoBox = document.getElementById('explr-vid-view-'+dt+'-' + postId + '-' + slideIndex);
            //console.log(videoBox);
            if (videoBox) {
                var cPlayer = videojs('explr-vid-pl-' + postId + '-' + slideIndex);
                //console.log(cPlayer);
                if(cPlayer && !cPlayer.paused())
                {
                    cPlayer.pause();
                }
            }        
        } catch (err) {
            console.error(`beforeSlide-Error: ${err}`);
        }
    }

    var afterSlide = (slideIndex, postId, dt=1) => {
        // console.log("ViewPost-afterSlide = ", slideIndex);
        // console.log("ViewPost-afterSlide =postId= ", postId);
        //console.log(sliderRef.currentSlide);

        if(slideIndex>(postSlideMaxModel-1))
        {
            
            if(dontDismissModelHide.current)
                CenterModalOpen("flex");
            else
                dontDismissModalClose();
        }
    }

    var boxSizeCalculations = (postMedia, dt=1) => {
        var mediaRatio, mediaWidth, mediaHeight; 
        mediaRatio = 1;
        var displayBoxWidth = width;

        //console.log('width', width , 'height', height, 'maxBoxWidth1024', maxBoxWidth1024, 'maxBoxWidth426', maxBoxWidth426, 'maxBoxWidth', maxBoxWidth);
 
        if (width == maxBoxWidth1024)
        {
            displayBoxWidth = maxBoxWidth1024 / 3 - 5;
        }
        else if (width > maxBoxWidth426)
        {
            displayBoxWidth = maxBoxWidth;
        }
        else
        {
            if(dt == 1)
                displayBoxWidth = displayBoxWidth - maxBoxPadding;
        }
        var displayBoxHeight = displayBoxWidth * mediaRatio;

        // if (postMedia.length == 0) 
        // {
        //     // no calc
        // }
        // else 
        if (postMedia.length == 1) 
        {
            // landscape
            
            // height={imageData.Media_Height} width={imageData.Media_Width} 
            postMedia.map((media, i) => {
                
                mediaWidth = parseFloat(media.Media_Width);
                mediaHeight = parseFloat(media.Media_Height);                
                
            });

            // if(mediaWidth > mediaHeight)
            // {
            //     mediaRatio = mediaHeight / mediaWidth;
            //     displayBoxHeight = displayBoxWidth * mediaRatio;
            // }

            //console.log({'mediaRatio':mediaRatio,'mediaWidth':mediaWidth, 'height':mediaHeight});

            //if (width < maxBoxWidth)
            //displayBoxHeight = displayBoxWidth * mediaRatio;
            if (mediaWidth !== undefined && !Number.isNaN(mediaWidth))
            {
                mediaRatio = mediaHeight / mediaWidth;
            }
            
            var newHeight = displayBoxWidth * mediaRatio;
            var maxHeight = displayBoxWidth;
            if(newHeight > maxHeight)
            {
                newHeight = maxHeight;
            }

            displayBoxHeight = newHeight;
        }
        else
        {
            //displayBoxHeight = displayBoxWidth * mediaRatio;
            displayBoxHeight = displayBoxWidth;
        }

        if(dt == 2)
        {
            //displayBoxWidth = displayBoxWidth - maxBoxPaddingWidthFull;   
            //displayBoxHeight = height - maxBoxPaddingHeightFull; 

            displayBoxWidth = width;
            displayBoxHeight = height-100;

            if(width >= maxBoxWidth768)
            {
                //var boxContainer = document.getElementsByClassName('top-div')[0]; 
                var boxContainer = document.querySelector('.block-box.post-box .postCard2');
                var offsetWidth = boxContainer.offsetWidth;
                displayBoxWidth = offsetWidth;
            }
        }       

        //console.log({'width':displayBoxWidth, 'height':displayBoxHeight});

        return {'width':displayBoxWidth, 'height':displayBoxHeight,'postMediaCount':postMedia.length};
    };


    // Media slider view image/video
    const mediaSlidView = (postMedia, post=null, dt=1) => {

        const postId = post.Post_ID?post.Post_ID:null;

        var displayDimensions = boxSizeCalculations(postMedia, dt);

        if(post.Post_Shared == "1")
        {
            displayDimensions.width = displayDimensions.width - 20;
        }

        var imageViewBox = "imageViewBox";
        var videoExplrView = "videoExplrView";
        
        // if(dt==2)
        // {
        //     imageViewBox = "imageViewBox225"; 
        //     videoExplrView = "videoExplrView225";
        // }

        //console.log("mediaSlidView", postMedia, postMedia.length);

        if (postMedia.length == 1) {
            return (<>
                    {postMedia.map((val, i) => {
                        if (val.Media_Type == "0" || val.Media_Type == "") {
                            if(dt==1)
                                imageViewBox = "imageViewBox3Single"; 
                            return (
                                <div className={imageViewBox} key={'explr-vid-view-1-'+postId+'-'+ i} style={{backgroundColor: val.Media_BG_Color, width:displayDimensions.width, height:displayDimensions.height}} onClick={() => onSetModalBox1({showModal:true,slideIndex:i,modalPost:post})} > 
                                    <CropImage key={'imageView-1-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} displayDimensions={displayDimensions} ></CropImage>
                                </div>
                            )
                        } else if (val.Media_Type == "2") {
                            return (<div key={'VideoView-explr-vid-view-5-'+postId+'-'+ i}>
                                {ExplurgedVideoView(val)}
                                <div className={videoExplrView} key={'explr-vid-view-2-'+postId+'-'+ i} style={{backgroundColor: val.Media_BG_Color, width:displayDimensions.width, height:displayDimensions.height}} onClick={() => onSetModalBox1({showModal:true,slideIndex:i,modalPost:post})} > 
                                    <CropImage key={'imageView-2-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} displayDimensions={displayDimensions} ></CropImage>
                                </div>
                            </div>)
                        }
                    })}
            </>)
        } else if (postMedia.length > 1) {
            
            const afterSlideConst = slideIndex => {
                afterSlide(slideIndex, postId);
            };
            const beforeSlideConst = slideIndex => {
                beforeSlide(slideIndex, postId);
            };
            var CarouselKey = 'crsl-1-'+postMedia.length+"-"+postId;
            //console.log("CarouselKey", CarouselKey);
            return (<>
                <Carousel key={CarouselKey} className='mediaSlider' afterSlide={afterSlideConst} beforeSlide={beforeSlideConst} enableKeyboardControls="true" swiping="true">
                    {postMedia.map((val, i) => {                        
                        if (val.Media_Type == "0" || val.Media_Type == "") {
                            return (
                                <div  className={imageViewBox} id={'explr-vid-view-3-'+postId+'-'+ i} key={'explr-vid-view-3-'+postId+'-'+ i} style={{backgroundColor: val.Media_BG_Color, width:displayDimensions.width, height:displayDimensions.height}} onClick={() => onSetModalBox1({showModal:true,slideIndex:i,modalPost:post})} >                                
                                    <CropImage key={'imageView-3-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} displayDimensions={displayDimensions} ></CropImage>
                                </div>                                
                            )
                        } else if (val.Media_Type == "2") {
                            return (<div key={'VideoView-explr-vid-view-6-'+postId+'-'+ i}>
                                {ExplurgedVideoView(val)}
                                <div className={videoExplrView} key={'explr-vid-view-4-'+postId+'-'+ i} id={'explr-vid-view-1-'+postId+'-'+i} style={{backgroundColor: val.Media_BG_Color, width:displayDimensions.width, height:displayDimensions.height}} onClick={() => onSetModalBox1({showModal:true,slideIndex:i,modalPost:post})} > 
                                    <CropImage key={'imageView-4-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} displayDimensions={displayDimensions} ></CropImage>
                                </div> 
                            </div>)
                        }
                    })}
                </Carousel>
                </>)
        } else {
            return (<></>)
        }
    }

    // Media slider view image/video
    const mediaSlidViewFullView = (postMedia, post=null, dt=1, slideIndex=0) => {

        const postId = post.Post_ID?post.Post_ID:null;

        var displayDimensions = boxSizeCalculations(postMedia, dt);

        if(post.Post_Shared == "1")
        {
            displayDimensions.width = displayDimensions.width - 20;
        }

        var boxWidth = displayDimensions.width;

        if(dt == 2)
        {   
            boxWidth = "100%";
            if(width >= maxBoxWidth768 && width < maxBoxWidth1024)
            {
                //var boxContainer = document.getElementsByClassName('top-div')[0]; 
                var boxContainer = document.querySelector('.block-box.post-box .postCard2');
                var offsetWidth = boxContainer.offsetWidth;
                boxWidth = offsetWidth;
            }
        }

        var imageViewBox = "imageViewBox";
        var videoExplrView = "videoExplrView";

        if (postMedia.length == 1) {
            return (<>
                    {postMedia.map((val, i) => {
                        if (val.Media_Type == "0" || val.Media_Type == "") {
                            if(dt==1)
                                imageViewBox = "imageViewBox3Single"; 
                            return (
                                <div className={imageViewBox} key={'mdl-1-explr-vid-view-2-'+postId+'-'+ i} style={{backgroundColor: val.Media_BG_Color, width:boxWidth, height:displayDimensions.height}} > 
                                    <CropImage key={'imageView-2-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} slideIndex={slideIndex} displayDimensions={displayDimensions} ></CropImage>
                                </div>
                            )
                        } else if (val.Media_Type == "2") {
                            return (<div key={'Media_Type-imageView-2-'+postId+'-'+i}>
                                {/* {ExplurgedVideoView(val)} */}
                                <div className={videoExplrView} key={'mdl-2-explr-vid-view-2-'+postId+'-'+ i} style={{backgroundColor: val.Media_BG_Color, width:boxWidth, height:displayDimensions.height}} > 
                                    <CropImage key={'imageView-2-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} slideIndex={slideIndex} displayDimensions={displayDimensions} ></CropImage>
                                </div>
                            </div>)
                        }
                    })}
            </>)
        } else if (postMedia.length > 1) {
            
            const afterSlideConst = slideIndex => {
                afterSlide(slideIndex, postId, 2);
            };
            const beforeSlideConst = slideIndex => {
                beforeSlide(slideIndex, postId, 2);
            };
            return (<>
                <Carousel slideIndex={slideIndex} key={'crsl-2-'+postId} className='mediaSlider' afterSlide={afterSlideConst} beforeSlide={beforeSlideConst} enableKeyboardControls="true" swiping="true">
                    {postMedia.map((val, i) => {
                        if (val.Media_Type == "0" || val.Media_Type == "") {
                            return (
                                <div className={imageViewBox} key={'explr-vid-view-2-'+postId+'-'+ i} style={{backgroundColor: val.Media_BG_Color, width:boxWidth, height:displayDimensions.height}} >                                
                                    <CropImage key={'imageView-2-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} slideIndex={slideIndex} displayDimensions={displayDimensions} ></CropImage>
                                </div>                                
                            )
                        } else if (val.Media_Type == "2") {
                            return (<div key={'Media_Type-imageView-2-'+postId+'-'+i}>
                                {/* {ExplurgedVideoView(val)} */}
                                <div className={videoExplrView} key={'explr-vid-view-2-'+postId+'-'+ i} id={'explr-vid-view-2-'+postId+'-'+i} style={{backgroundColor: val.Media_BG_Color, width:boxWidth, height:displayDimensions.height}} > 
                                    <CropImage key={'imageView-2-'+postId+'-'+i} postData={post} imageData={val} postId={postId} displayMode={dt} displayIndex={i} slideIndex={slideIndex} displayDimensions={displayDimensions} ></CropImage>
                                </div>
                            </div>)
                        }
                    })}
                </Carousel>
            </>)
        } else {
            return (<></>)
        }
    }    

    // Media slider view image/video
    const mediaSlidViewFullView2 = (postMedia, post=null, dt=1, slideIndex=0) => {
        //var displayDimensions = boxSizeCalculations(postMedia, dt);
        var imageViewBox = "imageViewBox";
        var backgroudColor = "#4a4b60";
        if (post.Post_Type == "0") { //Explurged In
            return (<>     
                <div className={imageViewBox}> 
                    <img className='imageView' src={post.Map_Place_Thumb_Photo} ></img>
                </div>              
            </>);            
        } else if (post.Post_Type == "2") { //Travelling to
            return (<>
                <div className={imageViewBox}> 
                    <img className='imageView' src={post.Map_Place_Thumb_Photo} ></img>
                </div>
            </>);            
        } else if (post.Post_Type == "3") { //Will go to              
            return (<>
                <div className={imageViewBox}> 
                    <img className='imageView' src={post.Map_Place_Thumb_Photo} ></img>
                </div>
            </>);             
        } else if (post.Post_Type == "9") { //Link Preview
            //var previewMetadata = JSON.parse(post.preview_metadata);

            var previewImg = "";
            try {
                // // 🔍 USAGE
                let previewMetadata = safeParsePreviewMetadata(post.preview_metadata);
                // // ✅ Result
                //console.log("✅ Cleaned Preview Metadata:", previewMetadata);

                // // Optional decoding
                previewImg = safeDecode(previewMetadata.pre_meta_image);

                // // ✅ Result
                //console.log("✅ Cleaned Preview previewImg:", previewImg);
            } catch (e) {
                //console.log("oops somthing went worng!")
                console.error("preview_metadata 2 error e1", e);               
            }

            return (<>
                <div className={imageViewBox}> 
                    <img className='imageView' src={previewImg} ></img>
                </div>
            </>);
        } else {
            return (<></>);
        }
    }     

    function urlify(text) {        
        return text.replace(linkRegex, function(url) {

            let withProtocol = url
        
            if(!withProtocol.startsWith("http")) {
              withProtocol = "http://" + url
            }
           
            const newStr = `<a href="${withProtocol}" target="_blank" >${url}</a>`

            //return '<a href="' + url + '" target="_blank">' + url + '</a>';
            return newStr;
        })
    }

    function replaceNLWithBr(txt) {
        return txt.replaceAll(/\n/g, "<br />");
    }

    function hashify(text) {        
        return text.replaceAll(hasHashRegex, function(hash) {
           
            //var newStr = `<a href="javascript:false" style="color:#2d97f7" onclick="${clickCenterModalOpen}" >${hash}</a>`

            var newStr = `<span style="color:#2d97f7">${hash}</span>`;
            return newStr;
        });
    }

    function tagiify(text) {        
        return text.replaceAll(tagHashRegex, function(hash) {
           
            //var newStr = `<a href="javascript:false" style="color:#2d97f7" onclick="${clickCenterModalOpen}" >${hash}</a>`

            var newStr = `<span style="color:#2d97f7">${hash}</span>`;
            return newStr;
        });
    }    

    const ReadMore = ({ children }) => {
        var post = children;
        // console.log(post);
        // console.log(post.Post_Text);
        //var Post_Text = decodeURIComponent(post.Post_Text);

        let Post_Text;

        try {
            Post_Text = decodeURIComponent(post.Post_Text);
        } catch (e) {
            console.warn('Failed to decode Post_Text:', e);
            // fallback: use original string
            Post_Text = post.Post_Text;
        }

        var text_length = 200;
        var mxL = 3;
        var tlns = Post_Text.match(regexNewLineCount).length;
        if(tlns > mxL)
        {
            // calculate length of 2 lines text
            // extract only 3 line
            var textLines = Post_Text.split("\n")
            var text2 = textLines[0] +"\n"+ textLines[1] +"\n"+ textLines[2] +"\n"+ textLines[3];
            var text2Length = text2.length;
            if(text_length > text2Length)
            {
                text_length = text2Length;
            }
        }

        Post_Text = replaceNLWithBr(Post_Text);
        // Post_Text = hashify(Post_Text);
        // Post_Text = tagiify(Post_Text);
        // Post_Text = urlify(Post_Text);

        Post_Text = parseTextSinglePass(Post_Text);
        //console.log("Post_Text", Post_Text);        
        
        if (Post_Text.length > 300 && post.Post_Type == constants.POST_TYPE_WITH_SAY_STR) // 5
        {            
            text_length = 300;
        }        
        let text = Post_Text;  
              
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => {
            setIsReadMore(!isReadMore);
        };

        if (text.length > text_length || tlns > mxL) {
            return (
                <p className="text">
                    {isReadMore ? ReactHtmlParser(text.slice(0, text_length)) : ReactHtmlParser(text)}
                    <span
                        onClick={clickCenterModalOpen}
                        className="read-or-hide"
                        style={{ color: "blue" }}
                    >
                        {isReadMore ? "...read more" : " show less"}
                    </span>
                </p>
            );
        } else {
            return (<>{ReactHtmlParser(text)}</>)
        }
    };

    const ReadMoreShared = ({ children }) => {
        var post = children;
        var Post_Text = decodeURIComponent(post.Shared_Post_Text);
        var text_length = 200;
        var mxL = 3;
        var tlns = Post_Text.match(regexNewLineCount).length;
        if(tlns > mxL)
        {
            // calculate length of 2 lines text
            // extract only 3 line
            var textLines = Post_Text.split("\n")
            var text2 = textLines[0] +"\n"+ textLines[1] +"\n"+ textLines[2] +"\n"+ textLines[3];
            var text2Length = text2.length;
            if(text_length > text2Length)
            {
                text_length = text2Length;
            }
        }

        Post_Text = replaceNLWithBr(Post_Text);
        Post_Text = hashify(Post_Text);
        Post_Text = tagiify(Post_Text);
        Post_Text = urlify(Post_Text);
        
        if (Post_Text.length > 300 && post.Post_Type == constants.POST_TYPE_WITH_SAY_STR) // 5
        {            
            text_length = 300;
        }        
        let text = Post_Text;  
              
        const [isReadMore, setIsReadMore] = useState(true);
        const toggleReadMore = () => {
            setIsReadMore(!isReadMore);
        };

        if (text.length > text_length || tlns > mxL) {
            return (
                <p className="text">
                    {isReadMore ? ReactHtmlParser(text.slice(0, text_length)) : ReactHtmlParser(text)}
                    <span
                        onClick={clickCenterModalOpen}
                        className="read-or-hide"
                        style={{ color: "blue" }}
                    >
                        {isReadMore ? "...read more" : " show less"}
                    </span>
                </p>
            );
        } else {
            return (<>{ReactHtmlParser(text)}</>)
        }
    };    

    var ExplurgedVideoViewConversion = (videoViewCount) => {
        //var k = videoViewCount / 1000;
        return (<>{videoViewCount}</>)
    };    
    
    var ExplurgedVideoView = (data) => {    
        var Media_View_Count = data.Media_View_Count;
        // MEDIA_TYPE_VIDEO == 2 == Media_Type
        if (data.Media_Type==constants.MEDIA_TYPE_VIDEO && Media_View_Count.toString().trim().length > 0) {
            return (<>
                <div className='videoViewCount'>
                    <img className='videoViewCount_Icon' src={eyeFillIcon1x}></img>
                    {ExplurgedVideoViewConversion(Media_View_Count)}
                </div>
            </>)
        } else {
            return (<>
                {/* <div className='videoViewCount'>
                    <img className='videoViewCount_Icon' src={eyeFillIcon1x}></img>
                    9998K
                </div> */}
            </>)
        }
    }
    var ExplurgedLevelIconView = (data) => {
        //console.log("ExplurgedLevelIconView",data);
        // Profile_Type: "1" // Business
        // Shared_Profile_Type: "2"
        // Post_Type: "1" 
        // Spread_Type: "0" 
        // Shared_Profile_Type: "2"
        // Post_Shared: "1"
        //if(post.Post_Shared == "1")
        if(data.Post_Shared == "1" && data.Shared_Profile_Type == "1")
        {
            return (<>                
            </>);
        }
        else if(data.Post_Shared == "0" && data.Profile_Type == "1")
        {
            return (<>                
            </>);
        }
        // Total_Explurged_Level
        // Total_Explurged_Score_Level
        var Explurged_Level = parseInt(data.Total_Explurged_Score_Level);
        if (Explurged_Level < 20000) { // Cobalt
            return (<>
                <div className="Circle_Level_Icon" >   
                    <img className='Level_Icon2' src={cobaltLevelIcon}></img>
                </div>
            </>)
        } else if (Explurged_Level < 50000) { // Silver
            return (<>
                <div className="Circle_Level_Icon" >
                    <img className='Level_Icon2' src={silverLevelIcon}></img>
                </div>
            </>)
        } else if (Explurged_Level < 100000) { // GOLD
            return (<>
                <div className="Circle_Level_Icon" >
                    <img className='Level_Icon2' src={goldLevelIcon}></img>
                </div>
            </>)
        } else if (Explurged_Level < 500000) { // Spectra
            return (<>
                <div className="Circle_Level_Icon" >
                    <img className='Level_Icon2' src={spectraLevelIcon}></img>
                </div>
            </>)
        } else { // Prime
            return (<>
                <div className="Circle_Level_Icon" >
                    <img className='Level_Icon2' src={primeLevelIcon}></img>
                </div>
            </>)
        }
    }

    var mergeTitleNDesc = (title, desc) => {
        var str = "<b>" + title +"</b> " +desc;
        //console.log("mergeTitleNDesc-",title.length);
        //console.log(desc.length);
        //console.log(str.length);
        if(str.length > 70)
            str = str.substring(0, 70) + "....";
        return str;
        
    };


    const bucketUserPics = (post) => {
        var bucketUsers = post.LastExplurged_UserPath;
        if (bucketUsers.length > 0) {
            bucketUsers = bucketUsers.map((val, i) => ({
                ...val,
                _uniqueKey: `bucketUsers-kudosProfile-${post.Post_ID}-${i}`
            }));
            //console.log(bucketUsers);
            return (<>
                {bucketUsers.map((val, i) => {     
                    return (
                        <img src={val.User_Profile_Path} alt="Avatar" className='kudosProfile' 
                        key={val._uniqueKey}
                        ></img>)                    
                })}
            </>)
        }
        return(<></>);
    }

    function removeTrailingNumbers(str) {
        str = str.replace(/(<b>Explurged-in)\d+(<\/b>)/, "$1$2");
        return str.replace(/\d+$/, "");
    }


    const bucketListTxt = (post) => {

        // if(post.Bucket_Status=="2" || post.Bucket_Status=="0")
        // {
        //     // get date Explurgedin_DateTime
        //     // Explurgedin_DateTime
        //     var BucketLabelText = post.BucketLabelText;
        //     //console.log("BucketLabelText", BucketLabelText);
        //     BucketLabelText = removeTrailingNumbers(BucketLabelText);
        //     //console.log("BucketLabelText", BucketLabelText);
        //     var Explurgedin_DateTime = post.Explurgedin_DateTime;
        //     //console.log("Explurgedin_DateTime", Explurgedin_DateTime);
        //     var timeText = postTimeViewBucket(Explurgedin_DateTime);
        //     // You Explurged-in {%DATE_TIME%}3
        //     //console.log("timeText", timeText);
        //     BucketLabelText = BucketLabelText.replace("{%DATE_TIME%}",timeText + " ");
        //     //console.log("BucketLabelText", BucketLabelText);
        //     return (<>
        //             <div>
        //                 <div className="bucketUsers1">
        //                     {bucketUserPics(post)}
        //                 </div>
        //                 <div className="bucketTest">
        //                     <div className="btn-bucket-center">                                
        //                         {ReactHtmlParser(BucketLabelText)}
        //                     </div>
        //                 </div>
        //             </div>                
        //     </>);
        // }
        return (<>
            <div className="btn-bucket-center">
                Now add in your <b>Bucket List !</b>
            </div>
        </>);
    }

     const ExplurgedWillGoTo = (post) => {
        // "Will_Go_To_Left_Month": "0",
        // "Will_Go_To_Left_Days": "0", 
        const postId = post.Post_ID?post.Post_ID:null;

        //console.log("ExplurgedWillGoTo-post", post);
        // Future_Travel_Date: "2025-08-23 11:50:52"

        //console.log("ExplurgedWillGoTo", post.Will_Go_To_Left_Month, post.Will_Go_To_Left_Days);

        // Parse as UTC
        const given = moment.utc(post.Future_Travel_Date, "YYYY-MM-DD HH:mm:ss");

        // Current local time
        const nowLocal = moment();

        // Compare
        if (given.isBefore(nowLocal)) {
            //console.log("Given UTC time is older than current local time.");
            return(<></>);
        } else {
            //console.log("Given UTC time is NOT older.");
        }


        var Will_Go_To_Left_Month = post.Will_Go_To_Left_Month;
        if(Will_Go_To_Left_Month.length==0)
            Will_Go_To_Left_Month = "00";
        if(Will_Go_To_Left_Month.length==1)
            Will_Go_To_Left_Month = "0" + Will_Go_To_Left_Month;

        var Will_Go_To_Left_Days = post.Will_Go_To_Left_Days;
        if(Will_Go_To_Left_Days.length==0)
            Will_Go_To_Left_Days = "00";
        if(Will_Go_To_Left_Days.length==1)
            Will_Go_To_Left_Days = "0" + Will_Go_To_Left_Days;

       
        return (<>
            <div className="row p-2 Will-Go-To-Box">
                <div className="col-6">Explurge begins in</div>
                <div className="col-3">
                    {Will_Go_To_Left_Month.split("").map((char, index) => (
                        <span className="will-go-to-month-day" key={'will-go-to-month-day-1-'+postId+index}>{char}</span>
                    ))}
                    {/* <span className="will-go-to-month-day">00</span>  */}
                    Months</div>
                <div className="col-3">
                    {Will_Go_To_Left_Days.split("").map((char, index) => (
                        <span className="will-go-to-month-day" key={'will-go-to-month-day-2-'+postId+index}>{char}</span>
                    ))}
                    {/* <span className="will-go-to-month-day">00</span>  */}
                    Days</div>
            </div>
        </>);
     }

    // Instead of creating a string, use JSX
    const LinkComponent = ({ url, clickCenterModalOpen }) => {
        return (
            <a
            href="#"
            onClick={(e) => {
                e.preventDefault(); // Prevent default link behavior
                clickCenterModalOpen(); // Call your function
            }}
            >
            {/* {url} */}
            {ReactHtmlParser(url)}            
            </a>
        );
    };


    const postMediaView = (post) => {

        //console.log("postMediaView", post);

        var postMediaLength = 0;

        var postMedia = post.Media_FilePath;

        if (typeof postMedia === "string") {
             return (<></>);
        }

        if(postMedia != undefined && postMedia != null && postMedia.length>0)
        {
            postMediaLength = postMedia.length;
        }

        if (post.Post_Type == "0" && postMediaLength > 0) { //Explurged In
            return (<>
                <div className='explurgen-with-media'>

                    {ExplurgedLevelIconView(post)}

                    {mediaSlidView(postMedia, post)}

                    {/* <div className="flex-parent">
                        <div className="Place_Photo_Box">
                            <CropImagePlacePhoto key={'place-photo-1-'+post.Post_ID} postData={post} postId={post.Post_ID} onSetModalBox2={onSetModalBox2} ></CropImagePlacePhoto>
                            
                        </div>
                        <div className="Map_Photo_Box">
                            <img className='Map_Photo_Img' src={post.Wall_Post_Map_Url}></img>
                        </div>
                    </div> */}
                    <div className="box-3">
                        <div className="card_add">
                            <div className="col-sm-12">
                                <div className="btn-text-down text-center">
                                    {bucketListTxt(post)}
                                    <button className="btn btn-light float-end AddbucketListBtn" onClick={clickCenterModalOpen}> + Bucket List</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        } else if (post.Post_Type == "0") { //Explurged In
            return (<>
                <div className='explurgen-with-media'>

                    {/* {ExplurgedLevelIconView(post)} */}

                    {/* {mediaSlidView(postMedia, post)} */}

                    <div className="flex-parent">
                        <div className="Place_Photo_Box">
                            <CropImagePlacePhoto key={'place-photo-1-'+post.Post_ID} postData={post} postId={post.Post_ID} onSetModalBox2={onSetModalBox2} ></CropImagePlacePhoto>
                            {/* <img className='Place_Photo_Img' src={post.Map_Place_Thumb_Photo} onClick={() => setModalBox2({showModal:true,slideIndex:0,modalPost:post})} ></img> */}
                        </div>
                        <div className="Map_Photo_Box">
                            <img className='Map_Photo_Img' src={post.Wall_Post_Map_Url}></img>
                        </div>
                    </div>
                    <div className="box-3">
                        <div className="card_add">
                            <div className="col-sm-12">
                                <div className="btn-text-down text-center">
                                    {bucketListTxt(post)}
                                    <button className="btn btn-light float-end AddbucketListBtn" onClick={clickCenterModalOpen}> + Bucket List</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>)
        } else if (post.Post_Type == "1") { //Pictures/Videos
            return (<>
                {ExplurgedLevelIconView(post)}
                {mediaSlidView(postMedia,post)}
            </>)
        } else if (post.Post_Type == "2" && postMediaLength > 0) { //Travelling to
            return (<>
                <div className='explurgen-with-media'>
                    {ExplurgedLevelIconView(post)}
                    {mediaSlidView(postMedia,post)}

                    {/* <div className="flex-parent">                        
                        <div className="Map_Photo_Box">
                            <img className='Map_Photo_Img' src={post.Wall_Post_Map_Url}></img>
                        </div>
                        <div className="Place_Photo_Box">
                            <CropImagePlacePhoto key={'place-photo-2-'+post.Post_ID} postData={post} postId={post.Post_ID} onSetModalBox2={onSetModalBox2} ></CropImagePlacePhoto>                            
                        </div>
                    </div> */}
                    <div className="box-3">
                        <div className="card_add">
                            <div className="col-sm-12">
                                <div className="btn-text-down text-center">
                                    {bucketListTxt(post)}
                                    <button className="btn btn-light float-end AddbucketListBtn" onClick={clickCenterModalOpen}> + Bucket List</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>)
        } else if (post.Post_Type == "2") { //Travelling to
            return (<>
                <div className='explurgen-with-media'>
                    {/* {ExplurgedLevelIconView(post)} */}
                    {/* {mediaSlidView(postMedia,post)} */}

                    <div className="flex-parent">
                        <div className="Place_Photo_Box">
                            <CropImagePlacePhoto key={'place-photo-2-'+post.Post_ID} postData={post} postId={post.Post_ID} onSetModalBox2={onSetModalBox2} ></CropImagePlacePhoto>                            
                        </div>
                        <div className="Map_Photo_Box">
                            <img className='Map_Photo_Img' src={post.Wall_Post_Map_Url}></img>
                        </div>
                    </div>
                    <div className="box-3">
                        <div className="card_add">
                            <div className="col-sm-12">
                                <div className="btn-text-down text-center">
                                    {bucketListTxt(post)}
                                    <button className="btn btn-light float-end AddbucketListBtn" onClick={clickCenterModalOpen}> + Bucket List</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </>)
        } else if (post.Post_Type == "3" && postMediaLength > 0) { //Will go to
            return (
                <>
                    {/* {ExplurgedLevelIconView(post)} */}
                    {mediaSlidView(postMedia,post)}
                    {ExplurgedWillGoTo(post)}
                    {/* <div className="flex-parent">                        
                        <div className="Place_Photo_Box">    
                            <CropImagePlacePhoto key={'place-photo-3-'+post.Post_ID} postData={post} postId={post.Post_ID} onSetModalBox2={onSetModalBox2} ></CropImagePlacePhoto>                        
                            
                        </div>
                        <div className="Map_Photo_Box">                       
                            <img className='Map_Photo_Img' src={post.Wall_Post_Map_Url}></img>
                        </div>
                    </div> */}
                </>
            )
        } else if (post.Post_Type == "3") { //Will go to
            return (
                <>
                    {/* {ExplurgedLevelIconView(post)} */}
                    {/* {mediaSlidView(postMedia,post)} */}
                    {ExplurgedWillGoTo(post)}
                    <div className="flex-parent">                        
                        <div className="Place_Photo_Box">    
                            <CropImagePlacePhoto key={'place-photo-3-'+post.Post_ID} postData={post} postId={post.Post_ID} onSetModalBox2={onSetModalBox2} ></CropImagePlacePhoto>                        
                            {/* <img className='Place_Photo_Img' src={post.Map_Place_Thumb_Photo} onClick={() => setModalBox2({showModal:true,slideIndex:0,modalPost:post})} ></img> */}
                        </div>
                        <div className="Map_Photo_Box">                       
                            <img className='Map_Photo_Img' src={post.Wall_Post_Map_Url}></img>
                        </div>
                    </div>
                    <div className="box-3">
                        <div className="card_add">
                            <div className="col-sm-12">
                                <div className="btn-text-down text-center">
                                    {bucketListTxt(post)}
                                    <button className="btn btn-light float-end AddbucketListBtn" onClick={clickCenterModalOpen}> + Bucket List</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )
        } else if (post.Post_Type == "4") { //along with
            return (
                <>
                    <p>along with</p>
                </>
            )
        } else if (post.Post_Type == "5") { //Say
            return (<>
                {/* <p className='postText'>{decodeURIComponent(postData.Post_Text)}</p> */}
            </>)
        } else if (post.Post_Type == "6") { //journey so far
            return (<>
                {ExplurgedLevelIconView(post)}
                {mediaSlidView(postMedia,post)}
            </>)
        } else if (post.Post_Type == "7") { //Profile Picture

            var displayDimensions = boxSizeCalculations(postMedia[0], 1);

            if(post.Post_Shared == "1")
            {
                displayDimensions.width = displayDimensions.width - 20;
            }

            var profileURL = null;
            postMedia.map((val, i) => {
                profileURL = val.Wall_Media_Path
            })

            return (<div className=''>

                {/* {postMedia.map((val, i) => {
                    return (<>
                        <img className='profilePic' src={val.Wall_Media_Path}></img>
                    </>)
                })} */}                

                <div className="row profile-pic-post-row imageViewBox" style={{ backgroundImage: `url(`+profileURL+`)`, backgroundColor: postMedia[0].Media_BG_Color, width:displayDimensions.width, height:displayDimensions.height }} onClick={() => onSetModalBox1({showModal:true,slideIndex:0,modalPost:post})} >
                    <CropProfileImage key={'profile-1-'+post.Post_ID} postData={post} postMedia={postMedia} postId={post.Post_ID} displayDimensions={displayDimensions} ></CropProfileImage>
                </div>
                <div className="col-sm-12 profile-pic-post-row2 polygonBox" 
                    style={{ width:displayDimensions.width, height:displayDimensions.height }}
                    onClick={() => onSetModalBox1({showModal:true,slideIndex:0,modalPost:post})}
                    >
                        {postMedia.map((val, i) => {
                            return (
                            <img key={'image_profile_post-2-'+post.Post_ID+'-'+i} className="circle_profile400" 
                                src={val.Wall_Media_Path} 
                                alt="image_profile_post"></img>                                    
                            )
                        })}
                </div>

            </div>)
        } else if (post.Post_Type == "8") { //Cover Picture

            var displayDimensions = boxSizeCalculations(postMedia, 1);
            if(post.Post_Shared == "1")
            {
                displayDimensions.width = displayDimensions.width - 20;
            }
            return (<>

                {postMedia.map((val, i) => {
                    return (<div key={'coverPic-imageView-2-'+post.Post_ID+'-'+i}>
                        {/* <div className={imageViewBox} key={'explr-vid-view-'+postId+'-'+ i} style={{backgroundColor: val.Media_BG_Color, width:displayDimensions.width, height:displayDimensions.height}} >                                
                            <CropImage key={'imageView-'+postId+'-'+i} imageData={val} postId={postId} displayMode={dt} displayIndex={i} displayDimensions={displayDimensions} ></CropImage>
                        </div> */}
                        <img className='coverPic' height={val.Media_Height} width={val.Media_Width} src={val.Wall_Media_Path} style={{backgroundColor: val.Media_BG_Color, width:displayDimensions.width, height:displayDimensions.height}} onClick={() => onSetModalBox1({showModal:true,slideIndex:i,modalPost:post})} ></img>
                        {/* <CropImage key={'imageView-'+postId+'-'+i} imageData={val} postId={postId} displayMode={dt} displayIndex={i} displayDimensions={displayDimensions} ></CropImage> */}
                    </div>)
                })
                }

            </>)
        } else if (post.Post_Type == "9") { //Link Preview
            // post.Post_Text
            //var Post_Text = decodeURIComponent(post.Post_Text);

            var Post_Text;

            try {
                Post_Text = decodeURIComponent(post.Post_Text);
            } catch (e) {
                console.warn('Failed to decode Post_Text:', e);
                // fallback: use original string
                Post_Text = post.Post_Text;
            }

            //var previewMetadata = JSON.parse(post.preview_metadata);

            var previewTitle = "";
            var previewUrl = "";
            var previewDesc = "";
            var previewImg = "";

            try {
                // // 🔍 USAGE
                let previewMetadata = safeParsePreviewMetadata(post.preview_metadata);
                // // ✅ Result
                //console.log("✅ Cleaned Preview Metadata:", previewMetadata);

                // // Optional decoding
                // previewMetadata.pre_meta_title = safeDecode(previewMetadata.pre_meta_title);
                // previewMetadata.pre_meta_desc = safeDecode(previewMetadata.pre_meta_desc);

                previewTitle = safeDecode(previewMetadata.pre_meta_title);
                previewUrl = safeDecode(previewMetadata.pre_meta_url);
                previewDesc = safeDecode(previewMetadata.pre_meta_desc);
                previewImg = safeDecode(previewMetadata.pre_meta_image);

                // // ✅ Result
                //console.log("✅ Cleaned Preview previewImg:", previewImg);
            } catch (e) {
                //console.log("oops somthing went worng!")
                console.error("preview_metadata 1 error e1", e);               
            }            

            //console.log("post.Post_Text-",Post_Text);

            Post_Text = previewUrl.match(/^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:\/\n]+)/im)[1].toUpperCase();
            //var Post_Text = ReactHtmlParser(previewUrl.replace(linkRegexHttpWww, replacerHttpWww).toUpperCase());

            //var titlenDesc = ReactHtmlParser(mergeTitleNDesc(previewTitle,previewDesc));

            return (<>
                <div className='row p0 linkPreviewRightBoxContainer'>
                    <div className='linkPreviewLeftBox'>
                        <img className='previewImg' src={previewImg} onClick={() => onSetModalBox2({showModal:true,slideIndex:0,modalPost:post})} ></img>
                    </div>
                    <div className='linkPreviewRightBox'>                    
                        <div className='linkPreviewRightBox2'>
                            <div className='linkPreviewRightBox3'>
                                {Post_Text}<br></br>
                                {/* <div className="a"><p className='previewTitle'></p></div> */}
                                {/* <div className="b"><p className='previewTitle'></p></div> */}
                                    {/* <a className='previewLink' onClick={clickCenterModalOpen} href="#">
                                    
                                    {ReactHtmlParser(mergeTitleNDesc(previewTitle,previewDesc))}
                                    
                                    </a> */}

                                    <LinkComponent url={mergeTitleNDesc(previewTitle,previewDesc)} clickCenterModalOpen={clickCenterModalOpen} />

                            </div>
                        </div>
                    </div>
                </div>
                
                
                
                
            </>)
        } else {
            return (<></>)
        }
    }

    function formatNumberShort(num) {
        let suffix = '';
        let value = num;
        if(num == 0)
        {
            return "";
        }

        if (num >= 10000000) { // 1 Crore
            value = num / 10000000;
            suffix = 'Cr';
        } else if (num >= 100000) { // 1 Lakh
            value = num / 100000;
            suffix = 'L';
        } else if (num >= 1000) { // 1 Thousand
            value = num / 1000;
            suffix = 'K';
        }

        // Format with Indian numbering system
        const formatter = new Intl.NumberFormat('en-IN', {
            minimumFractionDigits: value % 1 === 0 ? 0 : 1,
            maximumFractionDigits: 1
        });

        return formatter.format(value) + suffix;
    }

    const postFooterView = (post) => {
        //var kn = (post.Total_Post_Kudos_V1.length > 0) ? post.Total_Post_Kudos_V1 : 0;

        // "Total_Post_Kudos_V1": "1.2K",
        // "Total_Post_Says_V1": "258",
        // "Total_Post_Shares_V1": "32",    
    

        var kn = post.Total_Post_Kudos_V1;
        if(kn == "0")
        {
            kn = "";
        }
        var sn = post.Total_Post_Says_V1;
        if(sn == "0")
        {
            sn = "";
        }
        var psn = post.Total_Post_Shares_V1;
        if(psn == "0")
        {
            psn = "";
        }

        // if(post.Total_Post_Kudos_V1.length > 0 && post.Total_Post_Kudos_V1.length!="0")
        // {
        //     if(post.Total_Post_Kudos_V1.length > 1)
        //     {
        //        kn = 11; // more than 9
        //     }
        //     else if(post.Total_Post_Kudos_V1.length == 1)
        //     {
        //         kn = parseInt(post.Total_Post_Kudos_V1);
        //     }
        // }

        var i, kudoIcons = [], kudoURLs = [];
        for(i=0;i<3;i++){
            if(i<kn)
            {
                kudoIcons.push(KUDO_FILL_URL);
            }
            else
            {
                kudoIcons.push(KUDO_LINE_URL);
            }
            kudoURLs.push(KUDO_LINE_URL);
        }
        //var sn = (post.Total_Post_Says_V1 > 0) ? post.Total_Post_Says_V1 : 0;
        // var sn = 0;
        // if(post.Total_Post_Says_V1.length > 0 && post.Total_Post_Says_V1.length!="0")
        // {
        //     if(post.Total_Post_Says_V1.length > 1)
        //     {
        //         sn = 11; // more than 9
        //     }
        //     else if(post.Total_Post_Says_V1.length == 1)
        //     {
        //         sn = parseInt(post.Total_Post_Says_V1);
        //     }
        // }
        // var text_says = "say";
        // if(sn>1)
        // {
        //     text_says = "says";
        // }

        // var psn = 0;
        // if(post.Total_Post_Shares_V1.length > 0 && post.Total_Post_Shares_V1.length!="0")
        // {
        //     if(post.Total_Post_Shares_V1.length > 1)
        //     {
        //         psn = 11; // more than 9
        //     }
        //     else if(post.Total_Post_Shares_V1.length == 1)
        //     {
        //         psn = parseInt(post.Total_Post_Shares_V1);
        //     }
        // }

        if(kn == "" && sn == "" && psn == "")
        {
            return (<>
                <div className=" footer-post-kudos-view-box">
                    <div className="footer-post-kudos-container">
                        <p onClick={clickCenterModalOpen}>
                            {kudoIcons.map((kudoURL, i) => {
                                    return(
                                        <img src={kudoURL} className="kudimage" title="Kudos"
                                        key={"kudimage-1-"+kudoURL+i}
                                        ></img>
                                    )                                    
                                })}
                                &nbsp;
                        </p>
                        <p onClick={clickCenterModalOpen}><img src={SAY_URL} className="saysimage" title="Say"></img> &nbsp;</p>
                        <p onClick={clickCenterModalOpen}><img src={SPREAD_URL} className="spreadimage" title="Spread"></img> &nbsp;</p>
                        <p className="text-right"><img src={save_to_collection} className="spreadimage" title="Save To Collection" onClick={clickCenterModalOpen}></img></p>

                    </div>                    
                    {/* <div className="row ">
                        <div className="col-sm-4 footer-left-inner1" onClick={clickCenterModalOpen}>
                            <span className="pull-left text-muted my-tool-tip kudoVal2">
                                {kudoURLs.map((kudoURL, i) => {
                                    return(<>
                                        <img src={kudoURL} className="kudimage" title="Kudos"></img>
                                    </>)                                    
                                })}
                                <br></br>
                                Kudos
                            </span>
                        </div>
                        <div className="col-sm-4 footer-left-inner2" onClick={clickCenterModalOpen}>
                            <span className="pull-left text-muted my-tool-tip">
                                <img src={SAY_URL} className="saysimage" title="Kudos"></img><br></br>
                                Say
                            </span>
                        </div>
                        <div className='col-sm-4 footer-left-inner3 grayscale' onClick={clickCenterModalOpen}>
                            <span className="pull-left text-muted my-tool-tip spreadVal2">
                                <img src={SPREAD_URL} className="spreadimage" title="Kudos"></img><br></br>
                                Spread
                            </span>
                        </div>
                    </div> */}
                </div>
            </>)
        }
        else
        {

            return (<>   
                {/* 
                <div className=" side-upper">
                    <div className="row kudo-mark">
                        <div className="col-sm-6 footer-left-inner4 kudoVal" onClick={clickCenterModalOpen}>
                            <div className="kudo-count-container">   
                                <div className="kudo-user-names">
                                    {(kn > 0) ? kudosUserPics(post) : ""}
                                </div>
                                <div className="kudo-counts">
                                    {(kn > 0) ? kudosUserPics2(post.Total_Post_Kudos_V1,'kudos') : ""}
                                </div>
                            </div>
                        </div>
                        <div className="col-sm-6 footer-left-inner5 saysVal" onClick={clickCenterModalOpen}>                            
                            {(sn > 0) ? kudosUserPics2(post.Total_Post_Says_V1,text_says) : ""}
                            {(psn > 0) ? kudosUserPics3(post.Total_Post_Shares_V1, 'spread', sn) : ""}
                        </div>
                    </div>
                </div>
                <div className=" ">            
                    <div className=' mob_line_bottom'></div>
                </div>                          
                */}
                <div className=" footer-post-kudos-view-box">
                    <div className="footer-post-kudos-container" onClick={clickCenterModalOpen}>
                        <p>
                            {kudoIcons.map((kudoURL, i) => {
                                    return(
                                        <img src={kudoURL} className="kudimage" title="Kudos"
                                        key={"kudimage-2-"+kudoURL+i}
                                        ></img>
                                    )                                    
                                })}
                                &nbsp;{(kn)}
                        </p>
                        <p><img src={SAY_URL} className="saysimage" title="Say"></img> &nbsp;{(sn)}</p>
                        <p><img src={SPREAD_URL} className="spreadimage" title="Spread"></img> &nbsp;{(psn)}</p>
                        <p className="text-right"><img src={save_to_collection} className="spreadimage" title="Save To Collection"></img></p>

                    </div>
                    
                    {/* <div className="row ">
                        <div className="col-sm-4 footer-left-inner1" onClick={clickCenterModalOpen}>
                            <span className="pull-left text-muted my-tool-tip kudoVal2">
                                {kudoIcons.map((kudoURL, i) => {
                                    return(<>
                                        <img src={kudoURL} className="kudimage" title="Kudos"></img>
                                    </>)                                    
                                })}
                                <br></br>
                                Kudos
                            </span>
                        </div>
                        <div className="col-sm-4 footer-left-inner2" onClick={clickCenterModalOpen}>
                            <span className="pull-left text-muted my-tool-tip">
                                <img src={SAY_URL} className="saysimage" title="Kudos"></img><br></br>
                                Say
                            </span>
                        </div>
                        <div className='col-sm-4 footer-left-inner3 grayscale' onClick={clickCenterModalOpen}>
                            <span className="pull-left text-muted my-tool-tip spreadVal2">
                                <img src={SPREAD_URL} className="spreadimage" title="Kudos"></img><br></br>
                                Spread
                            </span>
                        </div>
                    </div> */}
                    
                </div>
                <div className=" post-user-names-box">
                    <div className="row kudo-mark">
                        <div className="col-sm-12 kudoVal" onClick={clickCenterModalOpen}>
                            <div className="kudo-count-container">   
                                <div className="kudo-user-names">
                                    {(kn > 0) ? kudosUserPics(post) : ""}
                                </div>                                
                            </div>
                        </div>                        
                    </div>
                </div>
            </>)
        }
    }

    const kudosUserPics2 = (cnt, txt) => {
        return (<>
            {(cnt)}&nbsp;{(txt)}
        </>)
    }

    const kudosUserPics3 = (cnt, txt, sn=0) => {
        if(sn==0)
        {
            return (<>
                {(cnt)}&nbsp;{(txt)}
            </>)
        }
        else
        {
            return (<>
                <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="currentColor" className="bi bi-dot" viewBox="0 0 16 16">
                    <path d="M8 9.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3"></path>
                </svg>
                {(cnt)}&nbsp;{(txt)}
            </>)
        }
    }    

    const kudosUserPics = (post) => {
        var postKudos = post.Engagement_User_Paths;
        if (postKudos.length > 0) {
            var kun = 0;
            var uNames = [];

            var kn = 0;
            if(post.Total_Post_Kudos_V1.length > 0 && post.Total_Post_Kudos_V1.length!="0")
            {
                kn =post.Total_Post_Kudos_V1.length;  
                if(post.Total_Post_Kudos_V1.length > 1)
                {
                    kn = 11; // more than 9
                }
                else if(post.Total_Post_Kudos_V1.length == 1)
                {
                    kn = parseInt(post.Total_Post_Kudos_V1);
                }              
            }

            var kudosProfileClass = "kudosProfile";

            if(kn==2)
            {
                kudosProfileClass = "kudosProfile2";
            }
            else if(kn==11)
            {
                kudosProfileClass = "kudosProfile3";
            }

            return (<>
                <div className="kudosUserPics">
                {postKudos.map((val, i) => {
                    if (kun < 3 && !(uNames.includes(val.User_FirstName))) {
                        kun += 1;
                        uNames.push(val.User_FirstName);
                        return (
                            <img src={val.Kudos_User_Thumb_Pic} title={val.User_FirstName} 
                            alt="Avatar" 
                            className={kudosProfileClass} 
                            style={{zIndex: 99 - kun }}
                            key={"kudosUserPic-3-"+val.Kudos_User_Thumb_Pic+i}
                            ></img>
                        )
                    }
                })}
                </div>
                <div className="names1-names2">
                    <span className="names1 text-secondary">
                        {(uNames.length>=0)?"Kudos by ":""}
                    </span>
                    <span className="names2">
                        {uNames.map((uName, i) => {
                            if (i < 2) {
                                if (i > 0) {
                                    return (<div key={"names1-names2-"+post.Post_ID+uName+i}>
                                        {" "} 
                                        <span className="text-secondary">&nbsp;and&nbsp;</span>
                                        {" "}  
                                        <b> {(uNames.length>2)?"Others":uName} </b>
                                    </div>)
                                }
                                else
                                {      
                                    return (<div key={"names1-names2-"+post.Post_ID+uName+i}>
                                        <b> {uName} </b>
                                    </div>)
                                }
                            }
                        })}    
                    </span>
                </div>
            </>)
        }
    }

    const BottomModalOpen = (display, actionName = null) => {
        //console.log("ViewPost-BottomModalOpen ", display);
        var modelBox = document.getElementById('staticBackdropBox');
        modelBox.style.display = display;
        var model = document.getElementById('staticBackdrop');
        //console.log("BottomModalOpen ", model, display);
        if (model) {
            model.style.display = display;
        }

        if (actionName != null && actionName == "D") {
            document.getElementById('hideNotNowInEndPopup').style.display = 'none';
        }

        //console.log(modelBox);
        if(display == "block" || display == "flex")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //$('body').addClass('modal-open');
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll
            //disableBodyScroll(modelBox);
            //lockScroll(modelBox);  
            
            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock();            
        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //$('body').removeClass('modal-open');
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll            
            //enableBodyScroll(modelBox); 
            //clearAllBodyScrollLocks();  
            //unlockScroll(modelBox); 
            
            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();            
        }
    }
    
    usePostMilestones(postData, BottomModalOpen);

    const modalClose = () => {
        //console.log("ViewPost-modalClose ");
        var modelBox = document.getElementById('staticBackdropBox');
        modelBox.style.display = 'none';
        var model = document.getElementById('staticBackdrop'); 
        if (model) {
            model.style.display = 'none';

            // bottomModelHide.current = false;
            // setTimeout(()=>{
            //     bottomModelHide.current = true;
            // },timeoutBottomModel);

            setFullProfileInAppModalClose((fullProfileInAppModalClose + 1));

            //console.log('fullProfileInAppModalClose-', fullProfileInAppModalClose, postCountMaxModelTimes);

            if(fullProfileInAppModalClose >= (postCountMaxModelTimes-1))
            {
                setFullProfileInAppModal(false);
            }            
        }
        document.body.style.overflow = 'unset';
        document.documentElement.style.overflow = "scroll";
        //$('body').removeClass('modal-open');
        //document.body.classList.remove("modal-open");

        // 5. Re-enable body scroll
        //console.log(modelBox);
        //enableBodyScroll(modelBox);
        //clearAllBodyScrollLocks();
        //unlockScroll(modelBox);   
        
        // iOS Popup scroll fix - When popup closes:
        unlockScrollNew();
        disableTouchBlock();           

    }

    const dontDismissModalClose = () => {
        //console.log("ViewPost-dontDismissModalClose ");
        var modelBox = document.getElementById('dontMissModalBox');
        modelBox.style.display = 'none';
        var model = document.getElementById('dontMissModal');
        if (model) {
            model.style.display = 'none';

            dontDismissModelHide.current = false;
            //handleDataToParentDontDismissModelHide(false);
            setTimeout(()=>{
                dontDismissModelHide.current = true;
                //handleDataToParentDontDismissModelHide(true);
            },timeoutDontDismissModel);
        }
        document.body.style.overflow = 'unset';
        document.documentElement.style.overflow = "scroll";
        //$('body').removeClass('modal-open');
        //document.body.classList.remove("modal-open");

        // 5. Re-enable body scroll
        //console.log(modelBox);
        //enableBodyScroll(modelBox);
        //clearAllBodyScrollLocks(); 
        //unlockScroll(modelBox);

        // iOS Popup scroll fix - When popup closes:
        unlockScrollNew();
        disableTouchBlock();           
    }    

    const clickCenterModalOpen = () => {
        //console.log("ViewPost-clickCenterModalOpen ");
        CenterModalOpen("flex");
    }

    const CenterModalOpen = (display) => {      
        //console.log("ViewPost-CenterModalOpen ", display);
        var modelBox = document.getElementById('dontMissModalBox');
        modelBox.style.display = display;
        var model = document.getElementById('dontMissModal');
        //console.log("CenterModalOpen ", model, display);
        if (model) {
            model.style.display = display;
        }
        //console.log(modelBox);
        if(display == "block" || display == "flex")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //$('body').addClass('modal-open');
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll            
            //disableBodyScroll(modelBox);
            //lockScroll(modelBox);   
            
            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock();            
        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //$('body').removeClass('modal-open');
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll
            //enableBodyScroll(modelBox);
            //clearAllBodyScrollLocks();
            //unlockScroll(modelBox); 
            
            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();            
        }        
    } 

    const ContinueModalOpen = (display) => {      
        if (hasRun.current) {
             return;
        }         
        hasRun.current = true;           
        //console.log("ViewPost-ContinueModalOpen ", display);
        var modelBox = document.getElementById('staticContinueWebsiteBox');
        modelBox.style.display = display;
        var model = document.getElementById('staticContinueWebsite');
        //console.log("ContinueModalOpen ", model, display);

        const modalDialog = model.querySelector('.modal-dialog');
        
        if (model) {
            model.style.display = display;
        }
        //console.log(modelBox);
        if(display == "block" || display == "flex")
        {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = "hidden";
            //$('body').addClass('modal-open');
            //document.body.classList.add("modal-open");

            // 4. Disable body scroll            
            //disableBodyScroll(modelBox);
            //lockScroll(modelBox);   
            
            // iOS Popup scroll fix- When popup opens:
            lockScrollNew();
            enableTouchBlock(); 
            
            requestAnimationFrame(() => {
                modalDialog.style.transform = 'translateY(0)';
            });            
            
            // header.sticky_top_header
            // z-index: 1000;
            const sticky_top_header = document.querySelector('header.sticky_top_header');
            sticky_top_header.style.zIndex = '0';            
        }
        else
        {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = "scroll";
            //$('body').removeClass('modal-open');
            //document.body.classList.remove("modal-open");

            // 5. Re-enable body scroll
            //enableBodyScroll(modelBox);
            //clearAllBodyScrollLocks();
            //unlockScroll(modelBox); 
            
            // iOS Popup scroll fix - When popup closes:
            unlockScrollNew();
            disableTouchBlock();  
            
            modalDialog.style.transform = 'translateY(100vh)';

            // header.sticky_top_header
            // z-index: 1000;
            const sticky_top_header = document.querySelector('header.sticky_top_header');
            sticky_top_header.style.zIndex = '1000';            
        }        
    }

    useEffect(() => {
        const handleLinkClick = (e) => {
            const link = e.target.closest("a"); // catch <a> even if child element clicked
            //console.log(link, link.getAttribute("class"));
            if(link && link.getAttribute("href") && link.getAttribute("class") == "Deep-Link-Open")
            {
                // const now = Date.now();
                // setTimeout(() => {
                //     if (Date.now() - now < 2000) {
                //         // app didn’t open
                //         window.parent.postMessage({ action: "openDeepLink", dl_url: constants.APP_APPLE_APP_STORE_URL }, "*");
                        
                //         //window.location.href =  constants.APP_APPLE_APP_STORE_URL;
                //     }
                // }, 1500);
            }
            else if (link && link.getAttribute("href")) {
                e.preventDefault(); // stop default navigation
                //const url = link.getAttribute("href");

                //console.log("Intercepted link:", url);

                // Example: open in new tab
                //window.open(url, "_blank");
                CenterModalOpen("flex");

                // Or if you want SPA navigation:
                // navigate(url) if using react-router
            }
        };

        document.addEventListener("click", handleLinkClick);
        return () => document.removeEventListener("click", handleLinkClick);
    }, []);    

    var touchSwipe = {};
    var touchMinDistance = 100; 
    var minYtouchDistance30 = 30;
    var maxXtouchDistance10 = 10;
    var minYtouchDistance50 = 50;       
    
    const _onTouchStart = (e) => {
        const touch = e.touches[0];
        touchSwipe = { x: touch.clientX,y: touch.clientY };
        //console.log("_onTouchStart-", touch, touchSwipe);
    }
    
    const  _onTouchMove = (e) => {
        const touch = e.changedTouches[0];
        //console.log("_onTouchMove-", touch, touchSwipe);
        if (e.changedTouches && e.changedTouches.length) {            
            touchSwipe.swiping = true;
        }
    }
    
    const  _onTouchEnd = (e,type) => {
        const touch = e.changedTouches[0];
        const absX = Math.abs(touch.clientX - touchSwipe.x);
        const absY = Math.abs(touch.clientY - touchSwipe.y);

        //console.log("_onTouchEnd-", touch, touchSwipe, absX, absY);

        if (touchSwipe.swiping) {
            //console.log("_onTouchEnd-1-", touch, touchSwipe);
            // check direction
            if(touch.clientY > touchSwipe.y)
            {
                if(
                    (absX == 0 && absY >= minYtouchDistance30) 
                    || (absX <= maxXtouchDistance10 && absY >= minYtouchDistance50) 
                    || (absY > touchMinDistance)
                )
                {
                    // touch down
                    //console.log("_onTouchEnd--2", touch, touchSwipe);                    
                    if(type == 2)
                    {
                        //setModalBox2({showModal:false,slideIndex:-1,modalPost:null});
                        onModelHide2();
                    }
                    else
                    {
                        //setModalBox({showModal:false,slideIndex:-1,modalPost:null});
                        onModelHide1();
                    }
                }
            }
        }
        touchSwipe = {};
    }   
    
    const  _onTouchEndBox1 = (e) => {
        _onTouchEnd(e,1);
    }
    const  _onTouchEndBox2 = (e) => {
        _onTouchEnd(e,2);
    }

    function PostInFullScreenVerticallyCenteredModal(props) {

        if(modalBox.modalPost == null)
        {
            return (<></>);
        }
        else
        {
            var post = modalBox.modalPost;
            var postMedia = post.Media_FilePath;
            return (<>
            <Modal
                {...props}
                
                aria-labelledby="fullscreen-centered-modal"
                centered
                id="PostInFullScreenVerticallyCenteredModal"

                dialogClassName="custom-modal-dialog"
                fullscreen 

            >
                <Modal.Header closeButton>
                {/* <img className='crossIcon' src={crossIcon3x} onClick={props.onHide}></img> */}
                {/* <Button onClick={props.onHide}><img className='crossIcon' src={crossIcon3x} onClick={props.onHide}></img></Button> */}
                {/* <Modal.Title id="contained-modal-title-vcenter">
                    Modal heading
                </Modal.Title> */}
                </Modal.Header>
                <Modal.Body className='p0 m0'>
                {/* <h4>Centered Modal</h4>
                <p>
                    Cras mattis consectetur purus sit amet fermentum. Cras justo odio,
                    dapibus ac facilisis in, egestas eget quam. Morbi leo risus, porta ac
                    consectetur ac, vestibulum at eros.
                </p> */}

                <div className='touch-on-popup'
                    onTouchStart={_onTouchStart} 
                    onTouchMove={_onTouchMove}
                    onTouchEnd={_onTouchEndBox1}
                            >
                    {mediaSlidViewFullView(postMedia,post,2,modalBox.slideIndex)}
                </div>

                </Modal.Body>
                {/* <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
                </Modal.Footer> */}
            </Modal>
            </>);
        }
    }

    function PostInFullScreenVerticallyCenteredModal2(props) {

        if(modalBox2.modalPost == null)
        {
            return (<></>);
        }
        else
        {
            var post = modalBox2.modalPost;
            var postMedia = post.Media_FilePath;

            var displayDimensions = boxSizeCalculations(postMedia, 2);
            var imageViewBox = "imageViewBoxFullScreen";
            var backgroudColor = "#4a4b60";

            if (post.Post_Type == "0") { //Explurged In

            } else if (post.Post_Type == "2") { //Travelling to

            } else if (post.Post_Type == "3") { //Will go to     

            } else if (post.Post_Type == "9") { //Link Preview

            } else {
                return (<></>);
            }    
            return (<>
            <Modal
                {...props}
                
                aria-labelledby="fullscreen-centered-modal"
                centered
                id="PostInFullScreenVerticallyCenteredModal2"

                dialogClassName="custom-modal-dialog"
                fullscreen               
            >
                <Modal.Header closeButton>
                </Modal.Header>
                <Modal.Body className='p0 m0'>
                    <div className='touch-on-popup-2'
                        onTouchStart={_onTouchStart}
                        onTouchMove={_onTouchMove}
                        onTouchEnd={_onTouchEndBox2}
                                > 
                        <div className={imageViewBox} style={{backgroundColor:backgroudColor, width:"100%", height:displayDimensions.height}} >
                            {mediaSlidViewFullView2(postMedia,post,2,modalBox.slideIndex)}    
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
            </>);
        }
    }

    var topPosition = null;

    const onModelEntered = () => {
        //console.log("onModelEntered----------------");
        // When the modal is shown, we want a fixed body

        //console.log("onModelEntered----------------", topPosition , window.scrollY);

        topPosition = window.scrollY;

        //console.log("onModelEntered----------------", topPosition , window.scrollY);

        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.scrollY}px`;        
    }

    const onModelExit = () => {
        //console.log("onModelExit----------------");

        // When the modal is hidden...
        //const scrollY = document.body.style.top;

        //console.log("onModelExit----------------", topPosition , scrollY, window.scrollY);

        document.body.style.position = '';
        document.body.style.top = '';
        //window.scrollTo(0, parseInt(topPosition || 0));

        window.scrollTo({top:parseInt(topPosition || 0)});

        //window.scrollTo(0, parseInt(scrollY || '0') * -1);
        //console.log("onModelExit----------------", topPosition , scrollY, window.scrollY);
    }
    

    const onModelExited1 = () => {
        //console.log("onModelExited1---------------1-");
        //onModelExit();
    }

    const onModelExited2 = () => {
        //console.log("onModelExited2---------------2-");
        //onModelExit();
    }
    

    const onModelEntered1 = () => {
        //console.log("onModelEntered1---------------1-");
        //onModelEntered();
    }

    const onModelEntered2 = () => {
        //console.log("onModelEntered2---------------2-");
        //onModelEntered();
    }

    const onModelShow1 = () => {
        //console.log("onModelShow1---------------1-");
    }

    const onModelShow2 = () => {
        //console.log("onModelShow2---------------2-");

    }

    const onModelHide1 = () => {

        //console.log("onModelHide1---------------1-");

        setModalBox({showModal:false,slideIndex:-1,modalPost:null});
        
        //onModelExit();
    }

    const onModelHide2 = () => {
        //console.log("onModelHide2---------------2-");


        setModalBox2({showModal:false,slideIndex:-1,modalPost:null});

        //onModelExit();
    }

    const onSetModalBox1 = (setModalBoxData) => {

        //console.log("onSetModalBox1---------------1-");

        setModalBox(setModalBoxData);
        //setModalBox({showModal:true,slideIndex:0,modalPost:post});
        //setModalBox({showModal:false,slideIndex:-1,modalPost:null})
    }

    const onSetModalBox2 = (setModalBoxData) => {
        //console.log("onSetModalBox2---------------2-");
        setModalBox2(setModalBoxData);
        //setModalBox2({showModal:true,slideIndex:0,modalPost:post});
        //setModalBox2({showModal:false,slideIndex:-1,modalPost:null})
    }    


    const normalPostOtherThanShared = (post, i) => {
        var btTxt = " ";
        var btTxtPT9 = " ";
        var postMedia = post.Media_FilePath;
        if(postMedia != undefined && postMedia.length == 0 )
        {
            btTxt = " bt ";

            if(post.Total_Post_Kudos_V1 != "0" || post.Total_Post_Says_V1 != "0" || post.Total_Post_Shares_V1 != "0")
            {
                btTxt = " ";
            }
        }
        else 
        {
            if(post.Post_Type == "9")
            {
                btTxtPT9 = " bbtm ";
            }
            else if(post.Total_Post_Kudos_V1 != "0" || post.Total_Post_Says_V1 != "0" || post.Total_Post_Shares_V1 != "0")
            {
                btTxt = " bbtm ";
            }            
        }
        if(post.Post_Type == "7")
        {
            btTxt = " ";
        }
        return (
            <>
                        <div className='row p0 p0170 post-item' data-index={i}>
                            {/* <div className='col-lg-4 p0'></div> */}
                            <div className='col p0'>
                                <div className={"post-"+(i+1) + "-"+ post.Post_ID+' row block-box p0 post-box'}>
                                    {/* {(i+1)} */}
                                    {/* <div className='col-sm-4'></div> */}
                                    <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard2'>
                                        <div className='box-1'>
                                            {postProfileView(post)}
                                            <br></br>
                                            <div className='postTextView'>
                                                <div className='col'>
                                                    {postTextView(post)}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard p0 m10px00'>                                     
                                        <div className={btTxt + ' box-1 00000000000'}>
                                            {/* {ExplurgedLevelIconView(post)} */}
                                            <div className='postMedia'>
                                                <div className={btTxtPT9}>
                                                {postMediaView(post)}
                                                </div>
                                            </div>
                                            {/* <br></br> */}
                                            <div className='kudosView'>
                                                <div >
                                                {postFooterView(post)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='col-sm-4'></div> */}
                                </div> 
                            </div> 
                            {/* <div className='col-lg-4 p0'></div> */}
                            <div className="post-bottom-sentinel" />
                        </div>         
            </>
        );
    } 
    const boxSharedPost = (post, i) => {
        var btTxt = " ";
        var btTxtPT9 = " ";
        var postMedia = post.Media_FilePath;
        // if(postMedia != undefined && postMedia.length == 0 )
        // {
        //     btTxt = " bt ";
        // }
        // else 
        // {
        //     if(post.Total_Post_Kudos_V1 == "0" && post.Total_Post_Says_V1 == "0" && post.Total_Post_Shares_V1 == "0")
        //     {
        //         btTxt = " bt ";
        //     }            
        // }       
        return (
            <>
                        <div className='row p0 p0170 post-item' data-index={i}>
                            {/* <div className='col-lg-4 p0'></div> */}
                            <div className='col p0'>
                                <div className={"post-"+(i+1) + "-"+ post.Post_ID+' row block-box p0 post-box'}>
                                    {/* {(i+1)} */}
                                    {/* <div className='col-sm-4'></div> */}
                                    <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard2'>
                                        <div className='box-1'>
                                            {postProfileView2(post,0)}
                                            <br></br>
                                            <div className='postTextView'>
                                                <div className='col'>
                                                    {postTextViewShared(post)}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard3 p0 m10px00 p010'>
                                        <div className='b1l_t box-1'>
                                            <div className='BoxPostWoner'>
                                                {postProfileView2(post,1)}
                                                <br></br>
                                                <div className='postTextView'>
                                                    <div className='col'>
                                                        {postTextView(post)}
                                                    </div>
                                                </div>
                                            </div>
                                            {/* <br></br> */}
                                            {/* {ExplurgedLevelIconView(post)} */}
                                            <div className='postMedia BoxPostWoner2'>
                                                <div >
                                                {postMediaView(post)}
                                                </div>
                                            </div>
                                            {/* <br></br> */}
                                        </div>
                                    </div>
                                    <div className='col-sm-12 col-md-12 col-lg-12 justify-content-center postCard3 p0 m10px00'>
                                        <div className={btTxt + ' box-1 1111111111111'}>                                            
                                            <div className='kudosView'>
                                                <div >
                                                {postFooterView(post)}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* <div className='col-sm-4'></div> */}
                                </div> 
                            </div> 
                            {/* <div className='col-lg-4 p0'></div> */}
                            <div className="post-bottom-sentinel" />
                        </div>              
            </>
        );
    }    


    //console.log("-------------------------------------------------------------");

    const noExplurgeYet = () => {
        if (!isActive && postData.length==0)
        {
            return (<>
                <div className='no_explurge_yet row p0 p0170'>
                    <div className='col col-sm-12 p0'>No Explurge / Post yet</div>
                    {/* <div className='col col-sm-12 p0 splashScreen'><img src={splashScreen}></img></div> */}
                </div>
            </>);
        }
        // CenterModalOpen("flex");
        // let element = document.querySelector("a.notNow");
        // if (element) {
        //     element.textContent = "Continue on the website"; // sets the text inside the <a> tag
        // }
        ContinueModalOpen("flex");
        return (<></>);
    }

    const loaderBox = () => {
        if (isActive)
        {
            return (<>
                <div className='loaderbox'>
                    <HashLoader key={"mainLoader-"+isActive} className='mainLoader'></HashLoader>
                </div>                
                {/* <div className='splashScreen'><img src={splashScreen}></img></div> */}
            </>);
        }
        return (<></>);
    }

    return (<>

            <PullToRefresh
                pullDownContent={<PullDownContent height = "100px" />}
                releaseContent={<ReleaseContent height = "100px" />}
                refreshContent={<RefreshContent height = "100px" />}
                pullDownThreshold={100}
                onRefresh={handleRefresh}
                triggerHeight={100}
                backgroundColor=''
                startInvisible={true}
            >            
                <div className='post-view-list'>         
                        <div className='loader text-center p0170'>
                            {isActive && loaderBox()}
                            {/* {isActive && <HashLoader key="mainLoader" className='mainLoader'></HashLoader>} */}
                        </div>

                        {postData.length>0 && postData.map((post, i) => { //post.Badge_Status ="1",
                            if(post.Post_Shared == "1")
                            {
                                return (<div key={"boxSharedPost-"+post.Post_ID+i}>
                                    {boxSharedPost(post, i)}
                                </div>)
                            }
                            else
                            {
                                return (<div key={"normalPostOtherThanShared-"+post.Post_ID+i}>
                                    {normalPostOtherThanShared(post, i)}                                
                                </div>)
                            }
                        })}     
                        
                        {noExplurgeYet()}
                </div> 
            </PullToRefresh>  

            <PostInFullScreenVerticallyCenteredModal
                show={modalBox.showModal}
                onHide={onModelHide1}     
                onShow={onModelShow1}     
                onEntered={onModelEntered1}  
                onExited={onModelExited1}
            ></PostInFullScreenVerticallyCenteredModal>        
            <PostInFullScreenVerticallyCenteredModal2
                show={modalBox2.showModal}
                onHide={onModelHide2}       
                onShow={onModelShow2}
                onEntered={onModelEntered2}
                onExited={onModelExited2}
            ></PostInFullScreenVerticallyCenteredModal2>  
            {/* {
                resfreshAllowed == 1 && 
                <Helmet>
                    <title>{metaTagData.APP_TITLE}</title>
                    
                    <meta name="description" content={metaTagData.APP_DESCRIPTION} />
                    <meta name="keywords" content={constants.APP_KEYWORDS} /> 

                    <meta property="og:title" content={metaTagData.APP_TITLE} />
                    <meta property="og:description" content={metaTagData.APP_DESCRIPTION} />
                    <meta property="og:image" content={metaTagData.APP_IMAGE} />  
                </Helmet>  
            }              */}
    </>);
}

export default ViewPost;